import { GraphQLClient } from "graphql-request";
import { RequestInit } from "graphql-request/dist/types.dom";
import {
	useQuery,
	useMutation,
	UseQueryOptions,
	UseMutationOptions,
} from "react-query";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
	{ [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
	{ [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(
	client: GraphQLClient,
	query: string,
	variables?: TVariables,
	requestHeaders?: RequestInit["headers"]
) {
	return async (): Promise<TData> =>
		client.request({
			document: query,
			variables,
			requestHeaders,
		});
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	BigInt: any;
	Date: any;
	DateTime: any;
	JSONObject: any;
	Time: any;
	Upload: any;
};

export type AddProductToCartCoupon = {
	code: Scalars["String"];
	discountValue: Scalars["Int"];
	originalPrice: Scalars["Int"];
};

export type AddPromotionToCartInput = {
	branchId: Scalars["Int"];
	orderFlowId: Scalars["Int"];
	promotionId: Scalars["Int"];
	quantity: Scalars["Int"];
	requirementIdProductIds: Array<RequirementIdProductId>;
	rewardIdProductIds: Array<RewardIdProductId>;
};

export type AllMenuSection = {
	__typename?: "AllMenuSection";
	main: Array<MenuSection>;
	special: Array<MenuSection>;
};

export type AuditLog = {
	__typename?: "AuditLog";
	changes: Scalars["String"];
	createdAt: Scalars["DateTime"];
	id: Scalars["Int"];
	newValue: Scalars["String"];
	oldValue: Scalars["String"];
	operator: Scalars["String"];
	targetPk: Scalars["String"];
};

export type AuditLogOrderByInput = {
	createdAt?: InputMaybe<SortOrder>;
};

export type AuditLogWhereInput = {
	resource?: InputMaybe<Scalars["String"]>;
};

export type Branch = {
	__typename?: "Branch";
	address: Scalars["String"];
	city: Scalars["String"];
	country: Scalars["String"];
	countryCode: Scalars["String"];
	googleMapLink: Scalars["String"];
	id: Scalars["Int"];
	latitude: Scalars["String"];
	longitude: Scalars["String"];
	name: Scalars["String"];
	operatingTimes: Array<OperatingTime>;
	phone: Scalars["String"];
	postalCode: Scalars["String"];
	region: Scalars["String"];
	shop: Shop;
	shopId: Scalars["BigInt"];
	status: Scalars["Int"];
	taxType: TaxType;
	taxes: Array<Tax>;
	timezone: Scalars["String"];
};

export type BranchProduct = {
	__typename?: "BranchProduct";
	branch: Branch;
	branchId: Scalars["Int"];
	id: Scalars["BigInt"];
	modifierGroupIds?: Maybe<Array<Scalars["BigInt"]>>;
	modifierGroups?: Maybe<Array<ModifierGroup>>;
	orderFlowIds?: Maybe<Array<Scalars["BigInt"]>>;
	position: Scalars["Int"];
	price: Scalars["Int"];
	product: Product;
	productId: Scalars["Int"];
	status: Scalars["Int"];
	validFrom: Scalars["Int"];
	validUntil: Scalars["Int"];
};

export type BranchProductWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
};

export type BranchWhereInput = {
	code?: InputMaybe<StringFilter>;
	id?: InputMaybe<IntFilter>;
	shopId?: InputMaybe<IntFilter>;
	status?: InputMaybe<IntFilter>;
};

export type Campaign = {
	__typename?: "Campaign";
	branchId: Scalars["BigInt"];
	campaignBranches: Array<CampaignBranch>;
	createdAt: Scalars["Int"];
	description: Scalars["String"];
	discountLevel: Scalars["Int"];
	discountUnit: Scalars["Int"];
	discountValue: Scalars["Int"];
	endAt: Scalars["Int"];
	extraData?: Maybe<Scalars["String"]>;
	id: Scalars["BigInt"];
	name: Scalars["String"];
	startAt: Scalars["Int"];
	status: Scalars["Int"];
	updatedAt: Scalars["Int"];
};

export type CampaignBranch = {
	__typename?: "CampaignBranch";
	branchId: Scalars["Int"];
	status: Scalars["Int"];
};

export type CampaignOrderByInput = {
	createdAt?: InputMaybe<SortOrder>;
};

export type CampaignWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
	name?: InputMaybe<StringFilter>;
	status?: InputMaybe<IntFilter>;
};

export type Cart = {
	__typename?: "Cart";
	id: Scalars["Int"];
	productConnection: Array<CartProduct>;
	promotionCarts: Array<PromotionCart>;
	sessionId: Scalars["String"];
	totalItems: Scalars["Int"];
	totalProductsPrice: Scalars["Int"];
};

export type CartOrderByInput = {
	id?: InputMaybe<SortOrder>;
};

export type CartProduct = {
	__typename?: "CartProduct";
	addons: Array<CartProductProductAddOn>;
	cartId: Scalars["Int"];
	extraData: Scalars["String"];
	id: Scalars["Int"];
	name: Scalars["String"];
	price: Scalars["Int"];
	product: Product;
	productId: Scalars["Int"];
	quantity: Scalars["Int"];
	status: CartProductStatus;
	subCartProducts: Array<SubCartProduct>;
};

export type CartProductOrderByInput = {
	id?: InputMaybe<SortOrder>;
};

export type CartProductProductAddOn = {
	__typename?: "CartProductProductAddOn";
	cartProductId: Scalars["Int"];
	productAddOn: ProductAddOn;
	productAddOnId: Scalars["Int"];
};

export enum CartProductStatus {
	Cancelled = "CANCELLED",
	New = "NEW",
	Preparing = "PREPARING",
	Ready = "READY",
}

export type CartProductWhereInput = {
	cartId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
};

export type CartWhereInput = {
	id?: InputMaybe<IntFilter>;
};

export type CheckoutInput = {
	address: Scalars["String"];
	branchId: Scalars["Int"];
	comment?: InputMaybe<Scalars["String"]>;
	deliveryMethod: DeliveryMethod;
	email: Scalars["String"];
	failureRedirectURL?: InputMaybe<Scalars["String"]>;
	firstName: Scalars["String"];
	lastName: Scalars["String"];
	orderFlowId: Scalars["Int"];
	paymentMethod: PaymentMethod;
	phone: Scalars["String"];
	successRedirectURL?: InputMaybe<Scalars["String"]>;
};

export type CheckoutResponse = {
	__typename?: "CheckoutResponse";
	invoiceUrl?: Maybe<Scalars["String"]>;
	order: Order;
	success: Scalars["Boolean"];
};

export type ConfirmEmailResponse = {
	__typename?: "ConfirmEmailResponse";
	message?: Maybe<Scalars["String"]>;
	success: Scalars["Boolean"];
};

export type ConfirmPhoneResponse = {
	__typename?: "ConfirmPhoneResponse";
	message?: Maybe<Scalars["String"]>;
	success: Scalars["Boolean"];
};

export enum ConfirmationChannel {
	Email = "EMAIL",
	Phone = "PHONE",
}

export type Coupon = {
	__typename?: "Coupon";
	campaignId: Scalars["BigInt"];
	code: Scalars["String"];
	couponBranchProducts: Array<CouponBranchProduct>;
	createdAt: Scalars["Int"];
	description: Scalars["String"];
	id: Scalars["BigInt"];
	maxQuota: Scalars["Int"];
	remainingQuota: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
	updatedAt: Scalars["Int"];
	userEmail: Scalars["String"];
	userId: Scalars["String"];
	userName: Scalars["String"];
	userPhone: Scalars["String"];
};

export type CouponBranchProduct = {
	__typename?: "CouponBranchProduct";
	branchProductId: Scalars["BigInt"];
	couponId: Scalars["BigInt"];
	discountValue: Scalars["Int"];
	productId: Scalars["BigInt"];
	quantity: Scalars["Int"];
	status: Scalars["Int"];
};

export type CouponOrderByInput = {
	createdAt?: InputMaybe<SortOrder>;
};

export type CouponWhereInput = {
	campaignId?: InputMaybe<IntFilter>;
	code?: InputMaybe<StringFilter>;
};

export type CouponWithCampaign = {
	__typename?: "CouponWithCampaign";
	campaignId: Scalars["BigInt"];
	code: Scalars["String"];
	createdAt: Scalars["Int"];
	description: Scalars["String"];
	discountLevel: Scalars["Int"];
	id: Scalars["BigInt"];
	maxQuota: Scalars["Int"];
	remainingQuota: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
	updatedAt: Scalars["Int"];
	userEmail: Scalars["String"];
	userId: Scalars["String"];
	userName: Scalars["String"];
	userPhone: Scalars["String"];
};

export type CreateBranchInput = {
	address: Scalars["String"];
	city: Scalars["String"];
	countryCode: Scalars["String"];
	googleMapLink: Scalars["String"];
	latitude: Scalars["String"];
	longitude: Scalars["String"];
	name: Scalars["String"];
	operatingTimes: Array<CreateOperatingTimeInput>;
	phone: Scalars["String"];
	postalCode: Scalars["String"];
	region: Scalars["String"];
	shopId: Scalars["Int"];
	taxType: TaxType;
	timezone: Scalars["String"];
};

export type CreateBranchProductInput = {
	branchId: Scalars["Int"];
	modifierGroupIds?: InputMaybe<Array<Scalars["Int"]>>;
	orderFlowIds?: InputMaybe<Array<Scalars["Int"]>>;
	position: Scalars["Int"];
	price: Scalars["Int"];
	status: Scalars["Int"];
	validFrom: Scalars["Int"];
	validUntil?: InputMaybe<Scalars["Int"]>;
};

export type CreateCampaignBranchInput = {
	branchId: Scalars["Int"];
	status: Scalars["Int"];
};

export type CreateCampaignInput = {
	campaignBranches: Array<CreateCampaignBranchInput>;
	description: Scalars["String"];
	discountLevel: Scalars["Int"];
	discountUnit: Scalars["Int"];
	discountValue: Scalars["Int"];
	endAt: Scalars["Int"];
	name: Scalars["String"];
	startAt: Scalars["Int"];
	status: Scalars["Int"];
};

export type CreateCategoryInput = {
	name: Scalars["String"];
	position?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<Scalars["Int"]>;
	validFrom: Scalars["Int"];
	validUntil?: InputMaybe<Scalars["Int"]>;
};

export type CreateConfirmationInput = {
	couponCode?: InputMaybe<Scalars["String"]>;
	method: ConfirmationChannel;
};

export type CreateConfirmationResponse = {
	__typename?: "CreateConfirmationResponse";
	email?: Maybe<Scalars["String"]>;
	message?: Maybe<Scalars["String"]>;
	phone?: Maybe<Scalars["String"]>;
	success: Scalars["Boolean"];
};

export type CreateCouponBranchProductInput = {
	branchProductId: Scalars["Int"];
	discountValue: Scalars["Int"];
	quantity: Scalars["Int"];
	status: Scalars["Int"];
};

export type CreateCouponInput = {
	campaignId: Scalars["BigInt"];
	code: Scalars["String"];
	couponBranchProducts: Array<CreateCouponBranchProductInput>;
	description?: InputMaybe<Scalars["String"]>;
	maxQuota: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
	userEmail?: InputMaybe<Scalars["String"]>;
	userName: Scalars["String"];
	userPhone?: InputMaybe<Scalars["String"]>;
};

export type CreateMealItemCategory = {
	categoryId: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type CreateMealItemProduct = {
	childId: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type CreateMembershipInput = {
	email?: InputMaybe<Scalars["String"]>;
	externalId: Scalars["String"];
	membershipPartnerId: Scalars["Int"];
	name: Scalars["String"];
	password: Scalars["String"];
	phone: Scalars["String"];
};

export type CreateMembershipPartnerInput = {
	description?: InputMaybe<Scalars["String"]>;
	discounts?: InputMaybe<Array<MembershipDiscountInput>>;
	inherit_discounts_from_global_settings: Scalars["Boolean"];
	name: Scalars["String"];
	status: Scalars["Int"];
};

export type CreateMembershipResponse = {
	__typename?: "CreateMembershipResponse";
	createdAt: Scalars["Int"];
	id: Scalars["BigInt"];
	membershipNumber: Scalars["String"];
	membershipPartnerId: Scalars["Int"];
	status: Scalars["Int"];
	updatedAt: Scalars["Int"];
	userId: Scalars["String"];
};

export type CreateModifierGroupInput = {
	branchId: Scalars["Int"];
	description: Scalars["String"];
	maxQuantity: Scalars["Int"];
	minQuantity: Scalars["Int"];
	modifiers?: InputMaybe<Array<CreateModifierInput>>;
	name: Scalars["String"];
	position: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
};

export type CreateModifierInput = {
	price: Scalars["Int"];
	ref: Scalars["Int"];
	status: Scalars["Int"];
};

export type CreateOperatingTimeInput = {
	closeTime: Scalars["String"];
	dayOfWeek: Scalars["Int"];
	openTime: Scalars["String"];
};

export type CreateOrUpdateModifierGroupInput = {
	id?: InputMaybe<Scalars["Int"]>;
	maxQuantity: Scalars["Int"];
	minQuantity: Scalars["Int"];
	modifiers?: InputMaybe<Array<CreateOrUpdateModifierInput>>;
	name: Scalars["String"];
	status: Scalars["Int"];
	type: Scalars["Int"];
};

export type CreateOrUpdateModifierInput = {
	id?: InputMaybe<Scalars["Int"]>;
	price: Scalars["Int"];
	ref: Scalars["Int"];
	status: Scalars["Int"];
};

export type CreateProductAddOnInput = {
	description?: InputMaybe<Scalars["String"]>;
	image?: InputMaybe<Scalars["String"]>;
	name: Scalars["String"];
	price: Scalars["Int"];
};

export type CreateProductInput = {
	branchProducts?: InputMaybe<Array<CreateBranchProductInput>>;
	categoryId?: InputMaybe<Scalars["Int"]>;
	description?: InputMaybe<Scalars["String"]>;
	image?: InputMaybe<Scalars["String"]>;
	imageUpload?: InputMaybe<Scalars["Upload"]>;
	mealItemCategories?: InputMaybe<Array<CreateMealItemCategory>>;
	mealItemProducts?: InputMaybe<Array<CreateMealItemProduct>>;
	name: Scalars["String"];
	productAddOnIds?: InputMaybe<Array<Scalars["Int"]>>;
	productLabels?: InputMaybe<Array<CreateProductProductLabelInput>>;
};

export type CreateProductLabelInput = {
	name: Scalars["String"];
};

export type CreateProductProductLabelInput = {
	product_label_id: Scalars["Int"];
};

export type CreatePromotionInput = {
	branchIds: Array<Scalars["Int"]>;
	imageUpload: Scalars["Upload"];
	name: Scalars["String"];
	requirements: Array<CreatePromotionRequirementInput>;
	rewards: Array<CreatePromotionRewardInput>;
	validFrom: Scalars["Date"];
	validUntil: Scalars["Date"];
};

export type CreatePromotionRequirementInput = {
	categoryId?: InputMaybe<Scalars["Int"]>;
	id?: InputMaybe<Scalars["Int"]>;
	productId?: InputMaybe<Scalars["Int"]>;
	quantity: Scalars["Int"];
};

export type CreatePromotionRewardInput = {
	categoryId?: InputMaybe<Scalars["Int"]>;
	discountUnit?: InputMaybe<DiscountUnit>;
	discountValue?: InputMaybe<Scalars["Int"]>;
	id?: InputMaybe<Scalars["Int"]>;
	productId?: InputMaybe<Scalars["Int"]>;
	quantity?: InputMaybe<Scalars["Int"]>;
};

export type CreateSubCartProductWithoutCartProductInput = {
	connectionType: SubCartProductConnectionType;
	mealItemCategoryId?: InputMaybe<Scalars["Int"]>;
	productId: Scalars["Int"];
};

export type CreateTaxInput = {
	branchIds?: InputMaybe<Array<Scalars["Int"]>>;
	name: Scalars["String"];
	percentage: Scalars["Int"];
};

export type DateFilter = {
	gt?: InputMaybe<Scalars["Date"]>;
	gte?: InputMaybe<Scalars["Date"]>;
	lt?: InputMaybe<Scalars["Date"]>;
	lte?: InputMaybe<Scalars["Date"]>;
};

export type DeleteTokenResponse = {
	__typename?: "DeleteTokenResponse";
	message: Scalars["String"];
};

export enum DeliveryMethod {
	Delivery = "DELIVERY",
	SelfCollection = "SELF_COLLECTION",
}

export enum DiscountUnit {
	Currency = "CURRENCY",
	Percentage = "PERCENTAGE",
}

export type FeatureToggle = {
	__typename?: "FeatureToggle";
	createdAt?: Maybe<Scalars["DateTime"]>;
	id: Scalars["Int"];
	key: Scalars["String"];
	updatedAt?: Maybe<Scalars["DateTime"]>;
	value: Scalars["Boolean"];
};

export type FeatureToggleWhereInput = {
	id?: InputMaybe<IntFilter>;
};

export type File = {
	__typename?: "File";
	name: Scalars["String"];
	url: Scalars["String"];
};

export type FileLog = {
	__typename?: "FileLog";
	createdAt: Scalars["BigInt"];
	id: Scalars["BigInt"];
	operator: Scalars["String"];
	resultFiles: Array<ResultFile>;
	sourceFile: File;
	status: Scalars["Int"];
};

export type FileLogWhereInput = {
	workflow?: InputMaybe<Scalars["Int"]>;
};

export type ForgotPasswordInput = {
	email?: InputMaybe<Scalars["String"]>;
};

export type ForgotPasswordResponse = {
	__typename?: "ForgotPasswordResponse";
	message?: Maybe<Scalars["String"]>;
	success?: Maybe<Scalars["Boolean"]>;
};

export type GetSignedUrlResponse = {
	__typename?: "GetSignedUrlResponse";
	signed_url: Scalars["String"];
};

export type GetUserMembershipResponse = {
	__typename?: "GetUserMembershipResponse";
	discounts: Array<MembershipDiscount>;
	isActive: Scalars["Boolean"];
	isReferralFromUsable: Scalars["Boolean"];
	isReferralUsable: Scalars["Boolean"];
	membershipNumber: Scalars["String"];
	membershipPartnerName: Scalars["String"];
	qr: Scalars["String"];
	referralCode: Scalars["String"];
	referralDiscount?: Maybe<MembershipDiscount>;
	referralFrom: Scalars["String"];
	referralFromUnusableReason: Scalars["String"];
	referralUnusableReason: Scalars["String"];
};

export type HistoryOrder = {
	__typename?: "HistoryOrder";
	address: Scalars["String"];
	branch: Branch;
	branchId: Scalars["Int"];
	code: Scalars["String"];
	comment?: Maybe<Scalars["String"]>;
	createdAt: Scalars["DateTime"];
	id: Scalars["Int"];
	orderFlowId: Scalars["BigInt"];
	scheduledAt: Scalars["Int"];
	snapshot?: Maybe<OrderSnapshot>;
	status: OrderStatus;
	updatedAt: Scalars["DateTime"];
};

export type IntFilter = {
	equals?: InputMaybe<Scalars["Int"]>;
	in?: InputMaybe<Array<Scalars["Int"]>>;
};

export type IsForgotPasswordTokenValidInput = {
	tokenForgotPassword?: InputMaybe<Scalars["String"]>;
};

export type IsForgotPasswordTokenValidResponse = {
	__typename?: "IsForgotPasswordTokenValidResponse";
	message?: Maybe<Scalars["String"]>;
	success?: Maybe<Scalars["Boolean"]>;
};

export type LoginInput = {
	couponCode?: InputMaybe<Scalars["String"]>;
	email?: InputMaybe<Scalars["String"]>;
	password: Scalars["String"];
	phone?: InputMaybe<Scalars["String"]>;
};

export type LoginResponse = {
	__typename?: "LoginResponse";
	isFirstLogin?: Maybe<Scalars["Boolean"]>;
	message?: Maybe<Scalars["String"]>;
	user?: Maybe<User>;
};

export type MeResponse = {
	__typename?: "MeResponse";
	countryCode?: Maybe<Scalars["String"]>;
	couponCode?: Maybe<Scalars["String"]>;
	email?: Maybe<Scalars["String"]>;
	firstName: Scalars["String"];
	id: Scalars["String"];
	lastName: Scalars["String"];
	phone?: Maybe<Scalars["String"]>;
};

export type MealItemCategory = {
	__typename?: "MealItemCategory";
	category: ProductCategory;
	categoryId: Scalars["Int"];
	id: Scalars["Int"];
	parentId: Scalars["Int"];
	parentProduct: Product;
	quantity: Scalars["Int"];
};

export type MealItemCoupon = {
	__typename?: "MealItemCoupon";
	code: Scalars["String"];
	discountValue: Scalars["Int"];
};

export type MealItemProduct = {
	__typename?: "MealItemProduct";
	childId: Scalars["Int"];
	childProduct: Product;
	parentId: Scalars["Int"];
	parentProduct: Product;
	quantity: Scalars["Int"];
};

export type Membership = {
	__typename?: "Membership";
	createdAt: Scalars["Int"];
	id: Scalars["BigInt"];
	isActive: Scalars["Boolean"];
	membershipNumber: Scalars["String"];
	membershipPartnerId: Scalars["Int"];
	status: Scalars["Int"];
	updatedAt: Scalars["Int"];
	userId: Scalars["String"];
};

export type MembershipDiscount = {
	__typename?: "MembershipDiscount";
	isReferral: Scalars["Boolean"];
	name: Scalars["String"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type MembershipDiscountInput = {
	end?: InputMaybe<Scalars["Int"]>;
	start: Scalars["Int"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type MembershipDiscountSetting = {
	__typename?: "MembershipDiscountSetting";
	is_default: Scalars["Boolean"];
	is_referral: Scalars["Boolean"];
	min_successful_order_count: Scalars["Int"];
	name: Scalars["String"];
	status: Scalars["Int"];
	tier: Scalars["Int"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type MembershipDiscountSettingInput = {
	is_default: Scalars["Boolean"];
	is_referral: Scalars["Boolean"];
	min_successful_order_count: Scalars["Int"];
	name: Scalars["String"];
	status: Scalars["Int"];
	tier: Scalars["Int"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type MembershipPartner = {
	__typename?: "MembershipPartner";
	createdAt: Scalars["Int"];
	description: Scalars["String"];
	discounts: Array<MembershipPartnerDiscount>;
	inherit_discounts_from_global_settings: Scalars["Boolean"];
	name: Scalars["String"];
	partnerId: Scalars["Int"];
	status: Scalars["Int"];
};

export type MembershipPartnerDiscount = {
	__typename?: "MembershipPartnerDiscount";
	end?: Maybe<Scalars["Int"]>;
	start: Scalars["Int"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type MembershipPartnerWhereInput = {
	name?: InputMaybe<StringFilter>;
	partnerId?: InputMaybe<IntFilter>;
	status?: InputMaybe<IntFilter>;
};

export type MembershipSetting = {
	__typename?: "MembershipSetting";
	discounts: Array<MembershipDiscountSetting>;
};

export type MembershipSettingUpdateInput = {
	discounts: Array<MembershipDiscountSettingInput>;
};

export type MembershipWhereInput = {
	membershipNumber?: InputMaybe<StringFilter>;
	membershipPartnerId?: InputMaybe<IntFilter>;
	phone?: InputMaybe<StringFilter>;
	status?: InputMaybe<IntFilter>;
	userId?: InputMaybe<StringFilter>;
};

export type MenuSection = {
	__typename?: "MenuSection";
	id: Scalars["Int"];
	items?: Maybe<Array<MenuSectionItem>>;
	name: Scalars["String"];
	position: Scalars["Int"];
};

export type MenuSectionItem = {
	__typename?: "MenuSectionItem";
	cloudinaryPublicId?: Maybe<Scalars["String"]>;
	coupon?: Maybe<MealItemCoupon>;
	description?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	image: Scalars["String"];
	labels?: Maybe<Array<MenuSectionItemLabel>>;
	name: Scalars["String"];
	position: Scalars["Int"];
	price: Scalars["Int"];
	slug: Scalars["String"];
};

export type MenuSectionItemCloudinaryPublicIdArgs = {
	publicIdSegments?: InputMaybe<Scalars["Int"]>;
};

export type MenuSectionItemLabel = {
	__typename?: "MenuSectionItemLabel";
	id: Scalars["Int"];
	name: Scalars["String"];
	position: Scalars["Int"];
};

export type Modifier = {
	__typename?: "Modifier";
	createdAt: Scalars["Int"];
	id: Scalars["BigInt"];
	modifierGroupId: Scalars["BigInt"];
	modifierParentId: Scalars["BigInt"];
	position: Scalars["Int"];
	price: Scalars["Int"];
	ref: Scalars["Int"];
	status: Scalars["Int"];
	updatedAt: Scalars["Int"];
};

export type ModifierGroup = {
	__typename?: "ModifierGroup";
	branchId: Scalars["Int"];
	createdAt: Scalars["Int"];
	description: Scalars["String"];
	id: Scalars["BigInt"];
	maxQuantity: Scalars["Int"];
	minQuantity: Scalars["Int"];
	modifiers?: Maybe<Array<Modifier>>;
	name: Scalars["String"];
	position: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
	updatedAt: Scalars["Int"];
};

export type ModifierGroupOrderByInput = {
	id?: InputMaybe<SortOrder>;
};

export type ModifierGroupWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
	status?: InputMaybe<IntFilter>;
};

export type Mutation = {
	__typename?: "Mutation";
	addProductToCartWithAddOns: CartProduct;
	addPromotionToCart: PromotionCart;
	checkout: CheckoutResponse;
	clearCart: Scalars["String"];
	confirmEmail: ConfirmEmailResponse;
	confirmPhone: ConfirmPhoneResponse;
	createBranch: Branch;
	createCampaign: Campaign;
	createCategory: ProductCategory;
	createConfirmation: CreateConfirmationResponse;
	createCoupon: Coupon;
	createMembership: CreateMembershipResponse;
	createMembershipPartner: MembershipPartner;
	createModifierGroup: ModifierGroup;
	createProduct: Product;
	createProductAddOn: ProductAddOn;
	createProductLabel: ProductLabel;
	createPromotion: Promotion;
	createTax: Tax;
	deleteAndClearCart: Scalars["Boolean"];
	deleteCartProduct: CartProduct;
	deleteCategory: ProductCategory;
	deleteFCMToken?: Maybe<DeleteTokenResponse>;
	deleteManyPromotions: Array<Scalars["Int"]>;
	deleteProduct: Product;
	deleteProductAddOn: ProductAddOn;
	deleteProductLabel: ProductLabel;
	deletePromotion: Promotion;
	deletePromotionCart: PromotionCart;
	deleteTax: Tax;
	forgotPassword: ForgotPasswordResponse;
	getSignedUrl: GetSignedUrlResponse;
	isForgotPasswordTokenValid: IsForgotPasswordTokenValidResponse;
	login: LoginResponse;
	logout: Scalars["Boolean"];
	/** @deprecated use Mutation.updateOrderAndNotify instead */
	notifyOrderStatusChange: Scalars["Boolean"];
	register: RegisterResult;
	resetPassword: ResetPasswordResponse;
	saveFCMToken?: Maybe<SaveTokenResponse>;
	updateBranch: Branch;
	updateCampaign: Campaign;
	updateCartProduct: CartProduct;
	/** For admin */
	updateCartProductStatus: CartProduct;
	updateCategory: ProductCategory;
	updateCoupon: Coupon;
	updateFeatureToggle: FeatureToggle;
	updateMembership: Membership;
	updateMembershipPartner: MembershipPartner;
	updateMembershipSettings?: Maybe<MembershipSetting>;
	updateModifierGroup: ModifierGroup;
	/** @deprecated use Mutation.updateOrderAndNotify instead */
	updateOrder: Order;
	updateOrderAndNotify: Order;
	updateProduct: Product;
	updateProductAddOn: ProductAddOn;
	updateProductLabel: ProductLabel;
	updateProfile: User;
	updatePromotion: Promotion;
	updatePromotionCart: PromotionCart;
	updateTax: Tax;
	validateCoupon: ValidateCouponResponse;
};

export type MutationAddProductToCartWithAddOnsArgs = {
	branchId: Scalars["Int"];
	coupon?: InputMaybe<AddProductToCartCoupon>;
	name: Scalars["String"];
	orderFlowId: Scalars["Int"];
	price: Scalars["Int"];
	productAddOnIds: Array<Scalars["Int"]>;
	productId: Scalars["Int"];
	quantity?: InputMaybe<Scalars["Int"]>;
	subProducts: Array<InputMaybe<CreateSubCartProductWithoutCartProductInput>>;
};

export type MutationAddPromotionToCartArgs = {
	values: AddPromotionToCartInput;
};

export type MutationCheckoutArgs = {
	input?: InputMaybe<CheckoutInput>;
};

export type MutationConfirmEmailArgs = {
	token: Scalars["String"];
};

export type MutationConfirmPhoneArgs = {
	otp: Scalars["String"];
};

export type MutationCreateBranchArgs = {
	values: CreateBranchInput;
};

export type MutationCreateCampaignArgs = {
	input?: InputMaybe<CreateCampaignInput>;
};

export type MutationCreateCategoryArgs = {
	values: CreateCategoryInput;
};

export type MutationCreateConfirmationArgs = {
	input: CreateConfirmationInput;
};

export type MutationCreateCouponArgs = {
	input: CreateCouponInput;
};

export type MutationCreateMembershipArgs = {
	input: CreateMembershipInput;
};

export type MutationCreateMembershipPartnerArgs = {
	input: CreateMembershipPartnerInput;
};

export type MutationCreateModifierGroupArgs = {
	values: CreateModifierGroupInput;
};

export type MutationCreateProductArgs = {
	values: CreateProductInput;
};

export type MutationCreateProductAddOnArgs = {
	values?: InputMaybe<CreateProductAddOnInput>;
};

export type MutationCreateProductLabelArgs = {
	values: CreateProductLabelInput;
};

export type MutationCreatePromotionArgs = {
	values: CreatePromotionInput;
};

export type MutationCreateTaxArgs = {
	values: CreateTaxInput;
};

export type MutationDeleteCartProductArgs = {
	id: Scalars["Int"];
};

export type MutationDeleteCategoryArgs = {
	id: Scalars["Int"];
};

export type MutationDeleteFcmTokenArgs = {
	token: Scalars["String"];
};

export type MutationDeleteManyPromotionsArgs = {
	where?: InputMaybe<PromotionWhereInput>;
};

export type MutationDeleteProductArgs = {
	id: Scalars["Int"];
};

export type MutationDeleteProductAddOnArgs = {
	id: Scalars["Int"];
};

export type MutationDeleteProductLabelArgs = {
	id: Scalars["Int"];
};

export type MutationDeletePromotionArgs = {
	id: Scalars["Int"];
};

export type MutationDeletePromotionCartArgs = {
	id: Scalars["Int"];
};

export type MutationDeleteTaxArgs = {
	id: Scalars["Int"];
};

export type MutationForgotPasswordArgs = {
	input?: InputMaybe<ForgotPasswordInput>;
};

export type MutationGetSignedUrlArgs = {
	workflow: Scalars["String"];
};

export type MutationIsForgotPasswordTokenValidArgs = {
	input?: InputMaybe<IsForgotPasswordTokenValidInput>;
};

export type MutationLoginArgs = {
	input?: InputMaybe<LoginInput>;
	isAdmin?: InputMaybe<Scalars["Boolean"]>;
	role?: InputMaybe<Scalars["String"]>;
};

export type MutationLogoutArgs = {
	isAdmin?: InputMaybe<Scalars["Boolean"]>;
};

export type MutationNotifyOrderStatusChangeArgs = {
	id: Scalars["Int"];
};

export type MutationRegisterArgs = {
	input?: InputMaybe<RegisterInput>;
};

export type MutationResetPasswordArgs = {
	input?: InputMaybe<ResetPasswordInput>;
};

export type MutationSaveFcmTokenArgs = {
	branchId: Scalars["Int"];
	token: Scalars["String"];
};

export type MutationUpdateBranchArgs = {
	id: Scalars["Int"];
	values: UpdateBranchInput;
};

export type MutationUpdateCampaignArgs = {
	input?: InputMaybe<UpdateCampaignInput>;
};

export type MutationUpdateCartProductArgs = {
	id: Scalars["Int"];
	values: UpdateCartProductInput;
};

export type MutationUpdateCartProductStatusArgs = {
	id: Scalars["Int"];
	status: CartProductStatus;
};

export type MutationUpdateCategoryArgs = {
	id: Scalars["Int"];
	values: UpdateCategoryInput;
};

export type MutationUpdateCouponArgs = {
	input: UpdateCouponInput;
};

export type MutationUpdateFeatureToggleArgs = {
	id: Scalars["Int"];
	key: Scalars["String"];
	value: Scalars["Boolean"];
};

export type MutationUpdateMembershipArgs = {
	input?: InputMaybe<UpdateMembershipInput>;
};

export type MutationUpdateMembershipPartnerArgs = {
	input: UpdateMembershipPartnerInput;
};

export type MutationUpdateMembershipSettingsArgs = {
	input: MembershipSettingUpdateInput;
};

export type MutationUpdateModifierGroupArgs = {
	id: Scalars["Int"];
	values: UpdateModifierGroupInput;
};

export type MutationUpdateOrderArgs = {
	id: Scalars["Int"];
	values: UpdateOrderInput;
};

export type MutationUpdateOrderAndNotifyArgs = {
	id: Scalars["Int"];
	values: UpdateOrderInput;
};

export type MutationUpdateProductArgs = {
	id: Scalars["Int"];
	values: UpdateProductInput;
};

export type MutationUpdateProductAddOnArgs = {
	id: Scalars["Int"];
	values?: InputMaybe<UpdateProductAddOnInput>;
};

export type MutationUpdateProductLabelArgs = {
	id: Scalars["Int"];
	values: UpdateProductLabelInput;
};

export type MutationUpdateProfileArgs = {
	values?: InputMaybe<UpdateProfileInput>;
};

export type MutationUpdatePromotionArgs = {
	id: Scalars["Int"];
	values: UpdatePromotionInput;
};

export type MutationUpdatePromotionCartArgs = {
	id: Scalars["Int"];
	values: UpdatePromotionCartInput;
};

export type MutationUpdateTaxArgs = {
	id: Scalars["Int"];
	values: UpdateTaxInput;
};

export type MutationValidateCouponArgs = {
	input: ValidateCouponInput;
};

export type MyPermissionResult = {
	__typename?: "MyPermissionResult";
	permissionCodes: Array<Scalars["String"]>;
	roleNames: Array<Scalars["String"]>;
};

export type OperatingTime = {
	__typename?: "OperatingTime";
	closeTime: Scalars["String"];
	dayOfWeek: Scalars["Int"];
	id: Scalars["Int"];
	openTime: Scalars["String"];
};

export type Order = {
	__typename?: "Order";
	address: Scalars["String"];
	branch: Branch;
	branchId: Scalars["Int"];
	cart: Cart;
	cartId: Scalars["Int"];
	code: Scalars["String"];
	comment?: Maybe<Scalars["String"]>;
	contactEmail: Scalars["String"];
	contactFirstname: Scalars["String"];
	contactLastname: Scalars["String"];
	countryCode: Scalars["String"];
	createdAt: Scalars["DateTime"];
	deliveryMethod: DeliveryMethod;
	id: Scalars["Int"];
	orderFlowId: Scalars["BigInt"];
	phone: Scalars["String"];
	scheduledAt: Scalars["Int"];
	shippings: Array<Shipping>;
	snapshot: Scalars["String"];
	status: OrderStatus;
	transaction?: Maybe<Transaction>;
	updatedAt: Scalars["DateTime"];
	user?: Maybe<User>;
	userId?: Maybe<Scalars["String"]>;
};

export type OrderByInputOrderByInput = {
	id?: InputMaybe<SortOrder>;
};

export type OrderFlow = {
	__typename?: "OrderFlow";
	id: Scalars["BigInt"];
	name: Scalars["String"];
	status: Scalars["Int"];
};

export type OrderFlowWhereInput = {
	id?: InputMaybe<IntFilter>;
	status?: InputMaybe<IntFilter>;
};

export type OrderOrderByInput = {
	code?: InputMaybe<SortOrder>;
	createdAt?: InputMaybe<SortOrder>;
};

export type OrderSnapshot = {
	__typename?: "OrderSnapshot";
	fee_breakdown: OrderSnapshotFeeBreakdown;
	items: Array<OrderSnapshotItem>;
	notes: Scalars["String"];
	order_flow: Scalars["String"];
	order_shipping?: Maybe<OrderSnapshotShipping>;
};

export type OrderSnapshotCoupon = {
	__typename?: "OrderSnapshotCoupon";
	code: Scalars["String"];
	discount_value: Scalars["Int"];
	original_price: Scalars["Int"];
};

export type OrderSnapshotDiscount = {
	__typename?: "OrderSnapshotDiscount";
	name: Scalars["String"];
	price: Scalars["Int"];
	unit: Scalars["Int"];
	value: Scalars["Int"];
};

export type OrderSnapshotFee = {
	__typename?: "OrderSnapshotFee";
	name: Scalars["String"];
	percentage: Scalars["Int"];
	value: Scalars["Int"];
};

export type OrderSnapshotFeeBreakdown = {
	__typename?: "OrderSnapshotFeeBreakdown";
	discounts: Array<OrderSnapshotDiscount>;
	fees: Array<OrderSnapshotFee>;
	subtotal: Scalars["Int"];
	taxes: Array<OrderSnapshotTax>;
};

export type OrderSnapshotItem = {
	__typename?: "OrderSnapshotItem";
	coupon?: Maybe<OrderSnapshotCoupon>;
	modifiers?: Maybe<Array<OrderSnapshotItemModifier>>;
	name: Scalars["String"];
	price: Scalars["Int"];
	product_id: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type OrderSnapshotItemModifier = {
	__typename?: "OrderSnapshotItemModifier";
	cart_modifier_id: Scalars["Int"];
	modifier_id: Scalars["Int"];
	name: Scalars["String"];
	price: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type OrderSnapshotShipping = {
	__typename?: "OrderSnapshotShipping";
	shipping_address: Scalars["String"];
	shipping_address_lat_lng: Scalars["String"];
	shipping_address_no: Scalars["String"];
};

export type OrderSnapshotTax = {
	__typename?: "OrderSnapshotTax";
	name: Scalars["String"];
	percentage: Scalars["Int"];
	value: Scalars["Int"];
};

export enum OrderStatus {
	Cancelled = "CANCELLED",
	DeliveryCancelled = "DELIVERY_CANCELLED",
	DeliveryEnRoute = "DELIVERY_EN_ROUTE",
	DeliveryFailed = "DELIVERY_FAILED",
	DeliveryPending = "DELIVERY_PENDING",
	DeliverySuccess = "DELIVERY_SUCCESS",
	New = "NEW",
	Preparing = "PREPARING",
	Ready = "READY",
	Received = "RECEIVED",
	Scheduled = "SCHEDULED",
}

export type OrderWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	code?: InputMaybe<StringFilter>;
	id?: InputMaybe<IntFilter>;
};

export type PaginatedAuditLogResponse = {
	__typename?: "PaginatedAuditLogResponse";
	edges: Array<AuditLog>;
	total: Scalars["Int"];
};

export type PaginatedBranchProductResponse = {
	__typename?: "PaginatedBranchProductResponse";
	edges: Array<BranchProduct>;
	total: Scalars["Int"];
};

export type PaginatedBranchResponse = {
	__typename?: "PaginatedBranchResponse";
	edges: Array<Branch>;
	total: Scalars["Int"];
};

export type PaginatedCampaignResponse = {
	__typename?: "PaginatedCampaignResponse";
	edges: Array<Campaign>;
	total: Scalars["Int"];
};

export type PaginatedCartProductResponse = {
	__typename?: "PaginatedCartProductResponse";
	edges: Array<CartProduct>;
	total: Scalars["Int"];
};

export type PaginatedCartResponse = {
	__typename?: "PaginatedCartResponse";
	edges: Array<Cart>;
	total: Scalars["Int"];
};

export type PaginatedCouponResponse = {
	__typename?: "PaginatedCouponResponse";
	edges: Array<Coupon>;
	total: Scalars["Int"];
};

export type PaginatedFeatureToggleResponse = {
	__typename?: "PaginatedFeatureToggleResponse";
	edges: Array<FeatureToggle>;
	total: Scalars["Int"];
};

export type PaginatedFileLogResponse = {
	__typename?: "PaginatedFileLogResponse";
	edges: Array<FileLog>;
	total: Scalars["Int"];
};

export type PaginatedMembershipPartnerResponse = {
	__typename?: "PaginatedMembershipPartnerResponse";
	edges: Array<MembershipPartner>;
	total: Scalars["Int"];
};

export type PaginatedMembershipResponse = {
	__typename?: "PaginatedMembershipResponse";
	edges: Array<Membership>;
	total: Scalars["Int"];
};

export type PaginatedModifierGroupResponse = {
	__typename?: "PaginatedModifierGroupResponse";
	edges: Array<ModifierGroup>;
	total: Scalars["Int"];
};

export type PaginatedOrderFlowResponse = {
	__typename?: "PaginatedOrderFlowResponse";
	edges: Array<OrderFlow>;
	total: Scalars["Int"];
};

export type PaginatedOrderResponse = {
	__typename?: "PaginatedOrderResponse";
	edges: Array<Order>;
	total: Scalars["Int"];
};

export type PaginatedProductAddOnResponse = {
	__typename?: "PaginatedProductAddOnResponse";
	edges: Array<ProductAddOn>;
	total: Scalars["Int"];
};

export type PaginatedProductCategoryResponse = {
	__typename?: "PaginatedProductCategoryResponse";
	edges: Array<ProductCategory>;
	total: Scalars["Int"];
};

export type PaginatedProductLabelResponse = {
	__typename?: "PaginatedProductLabelResponse";
	edges: Array<ProductLabel>;
	total: Scalars["Int"];
};

export type PaginatedProductResponse = {
	__typename?: "PaginatedProductResponse";
	edges: Array<Product>;
	total: Scalars["Int"];
};

export type PaginatedPromotionCartResponse = {
	__typename?: "PaginatedPromotionCartResponse";
	edges: Array<PromotionCart>;
	total: Scalars["Int"];
};

export type PaginatedPromotionRequirementResponse = {
	__typename?: "PaginatedPromotionRequirementResponse";
	edges: Array<PromotionRequirement>;
	total: Scalars["Int"];
};

export type PaginatedPromotionResponse = {
	__typename?: "PaginatedPromotionResponse";
	edges: Array<Promotion>;
	total: Scalars["Int"];
};

export type PaginatedRoleResponse = {
	__typename?: "PaginatedRoleResponse";
	edges: Array<Role>;
	total: Scalars["Int"];
};

export type PaginatedTaxResponse = {
	__typename?: "PaginatedTaxResponse";
	edges: Array<Tax>;
	total: Scalars["Int"];
};

export type PaginatedUserResponse = {
	__typename?: "PaginatedUserResponse";
	edges: Array<User>;
	total: Scalars["Int"];
};

export enum PaymentMethod {
	Cash = "cash",
	Cashless = "cashless",
}

export type Product = {
	__typename?: "Product";
	addons?: Maybe<Array<ProductAddOn>>;
	branchProduct?: Maybe<BranchProduct>;
	branchProducts: Array<Maybe<BranchProduct>>;
	category?: Maybe<ProductCategory>;
	categoryId?: Maybe<Scalars["Int"]>;
	cloudinaryPublicId?: Maybe<Scalars["String"]>;
	coupon?: Maybe<ProductCoupon>;
	createdAt?: Maybe<Scalars["Date"]>;
	description?: Maybe<Scalars["String"]>;
	extraData?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	image?: Maybe<Scalars["String"]>;
	isActive: Scalars["Boolean"];
	labels?: Maybe<Array<ProductLabel>>;
	mealItemCategories: Array<MealItemCategory>;
	mealItemProducts: Array<MealItemProduct>;
	name: Scalars["String"];
	ordering: Scalars["Int"];
	price: Scalars["Int"];
	productAddOnIds?: Maybe<Array<Scalars["Int"]>>;
	productLabelIds?: Maybe<Array<Scalars["Int"]>>;
	productLabels?: Maybe<Array<Maybe<ProductProductLabel>>>;
	slug: Scalars["String"];
	validFrom?: Maybe<Scalars["Date"]>;
	validUntil?: Maybe<Scalars["Date"]>;
};

export type ProductBranchProductArgs = {
	branchId?: InputMaybe<Scalars["Int"]>;
};

export type ProductCloudinaryPublicIdArgs = {
	publicIdSegments?: InputMaybe<Scalars["Int"]>;
};

export type ProductAddOn = {
	__typename?: "ProductAddOn";
	description?: Maybe<Scalars["String"]>;
	extraData?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	image?: Maybe<Scalars["String"]>;
	name: Scalars["String"];
	price: Scalars["Int"];
};

export type ProductAddOnOrderByInput = {
	created_at?: InputMaybe<SortOrder>;
	name?: InputMaybe<SortOrder>;
};

export type ProductAddOnWhereInput = {
	id?: InputMaybe<IntFilter>;
	name?: InputMaybe<StringFilter>;
};

export type ProductCategory = {
	__typename?: "ProductCategory";
	activeProducts: Array<Product>;
	description?: Maybe<Scalars["String"]>;
	extraData?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	name: Scalars["String"];
	position: Scalars["Int"];
	products: Array<Product>;
	status: Scalars["Int"];
	validFrom: Scalars["Int"];
	validUntil: Scalars["Int"];
};

export type ProductCategoryActiveProductsArgs = {
	where?: InputMaybe<ProductWhereInput>;
};

export type ProductCategoryOrderByInput = {
	name?: InputMaybe<SortOrder>;
};

export type ProductCategoryWhereInput = {
	id?: InputMaybe<IntFilter>;
	name?: InputMaybe<StringFilter>;
	status?: InputMaybe<IntFilter>;
	validFrom?: InputMaybe<IntFilter>;
	validUntil?: InputMaybe<IntFilter>;
};

export type ProductCoupon = {
	__typename?: "ProductCoupon";
	code: Scalars["String"];
	discountValue: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type ProductLabel = {
	__typename?: "ProductLabel";
	id: Scalars["Int"];
	name: Scalars["String"];
	products: Array<Product>;
};

export type ProductLabelOrderByInput = {
	name?: InputMaybe<SortOrder>;
};

export type ProductLabelWhereInput = {
	id?: InputMaybe<IntFilter>;
	name?: InputMaybe<StringFilter>;
};

export type ProductNotFound = {
	__typename?: "ProductNotFound";
	message: Scalars["String"];
};

export type ProductOrderByInput = {
	createdAt?: InputMaybe<SortOrder>;
	name?: InputMaybe<SortOrder>;
};

export type ProductProductLabel = {
	__typename?: "ProductProductLabel";
	position: Scalars["Int"];
	productLabel: ProductLabel;
	product_id: Scalars["Int"];
	product_label_id: Scalars["Int"];
	status: Scalars["Int"];
};

export type ProductResult = Product | ProductNotFound;

export type ProductWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
	isActive?: InputMaybe<Scalars["Boolean"]>;
	name?: InputMaybe<StringFilter>;
	validFrom?: InputMaybe<DateFilter>;
	validUntil?: InputMaybe<DateFilter>;
};

export type Promotion = {
	__typename?: "Promotion";
	branches: Array<Branch>;
	cloudinaryPublicId?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	image: Scalars["String"];
	isActive: Scalars["Boolean"];
	name: Scalars["String"];
	requirements: Array<PromotionRequirement>;
	rewards: Array<PromotionReward>;
	validFrom: Scalars["Date"];
	validUntil: Scalars["Date"];
};

export type PromotionCloudinaryPublicIdArgs = {
	publicIdSegments?: InputMaybe<Scalars["Int"]>;
};

export type PromotionCart = {
	__typename?: "PromotionCart";
	cart: Cart;
	cartId: Scalars["Int"];
	id: Scalars["Int"];
	promotion: Promotion;
	promotionCartsOnProducts: Array<PromotionCartOnProducts>;
	promotionId: Scalars["Int"];
	quantity: Scalars["Int"];
	status: PromotionCartStatus;
};

export type PromotionCartOnProducts = {
	__typename?: "PromotionCartOnProducts";
	connectionType: PromotionToProductConnectionType;
	product: Product;
	productId: Scalars["Int"];
	promotionCartId: Scalars["Int"];
	promotionRequirementId?: Maybe<Scalars["Int"]>;
	promotionRewardId?: Maybe<Scalars["Int"]>;
	quantity: Scalars["Int"];
};

export type PromotionCartOrderByInput = {
	id?: InputMaybe<SortOrder>;
};

export enum PromotionCartStatus {
	Cancelled = "CANCELLED",
	New = "NEW",
	Preparing = "PREPARING",
	Ready = "READY",
}

export type PromotionCartWhereInput = {
	cartId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
};

export type PromotionOrderByInput = {
	name?: InputMaybe<SortOrder>;
	validFrom?: InputMaybe<SortOrder>;
	validUntil?: InputMaybe<SortOrder>;
};

export type PromotionRequirement = {
	__typename?: "PromotionRequirement";
	category?: Maybe<ProductCategory>;
	categoryId?: Maybe<Scalars["Int"]>;
	id: Scalars["Int"];
	product?: Maybe<Product>;
	productId?: Maybe<Scalars["Int"]>;
	promotion: Promotion;
	promotionId: Scalars["Int"];
	quantity: Scalars["Int"];
};

export type PromotionReward = {
	__typename?: "PromotionReward";
	category?: Maybe<ProductCategory>;
	categoryId?: Maybe<Scalars["Int"]>;
	discountUnit?: Maybe<DiscountUnit>;
	discountValue?: Maybe<Scalars["Int"]>;
	id: Scalars["Int"];
	product?: Maybe<Product>;
	productId?: Maybe<Scalars["Int"]>;
	promotionId: Scalars["Int"];
	quantity?: Maybe<Scalars["Int"]>;
};

export enum PromotionToProductConnectionType {
	Requirement = "REQUIREMENT",
	Reward = "REWARD",
}

export type PromotionWhereInput = {
	branchId?: InputMaybe<IntFilter>;
	id?: InputMaybe<IntFilter>;
	isActive?: InputMaybe<Scalars["Boolean"]>;
	validFrom?: InputMaybe<DateFilter>;
	validUntil?: InputMaybe<DateFilter>;
};

export type Query = {
	__typename?: "Query";
	/** @deprecated Deprecated in favor of Query.myCart */
	getActiveCart?: Maybe<Cart>;
	getActiveCartProduct: Array<CartProduct>;
	getBranch: Branch;
	getBranchProduct?: Maybe<BranchProduct>;
	getCampaign: Campaign;
	getCart: Cart;
	getCartProduct: CartProduct;
	getCategory?: Maybe<ProductCategory>;
	getCoupon: Coupon;
	getCustomer: User;
	getFeatureToggle: FeatureToggle;
	getMembership: Membership;
	getMembershipPartner: MembershipPartner;
	getMembershipSettings: MembershipSetting;
	getModifierGroup: ModifierGroup;
	getOrder: Order;
	getProduct: ProductResult;
	getProductAddOn: ProductAddOn;
	getProductLabel: ProductLabel;
	getPromotion: Promotion;
	getTax: Tax;
	getUserMembership: GetUserMembershipResponse;
	historyOrders: Array<HistoryOrder>;
	listActiveCampaigns: Array<Campaign>;
	/** @deprecated use listMenuSections instead */
	listActiveCategories: PaginatedProductCategoryResponse;
	listAuditLogs: PaginatedAuditLogResponse;
	listBranchProducts: PaginatedBranchProductResponse;
	listBranches: PaginatedBranchResponse;
	listCampaigns: PaginatedCampaignResponse;
	listCartProducts: PaginatedCartProductResponse;
	listCarts: PaginatedCartResponse;
	listCategories: PaginatedProductCategoryResponse;
	listCoupons: PaginatedCouponResponse;
	listCustomers: PaginatedUserResponse;
	listFeatureToggles: PaginatedFeatureToggleResponse;
	listFileLogs: PaginatedFileLogResponse;
	listMembership: PaginatedMembershipResponse;
	listMembershipPartner: PaginatedMembershipPartnerResponse;
	listMenuSections: AllMenuSection;
	listModifierGroups: PaginatedModifierGroupResponse;
	listOrderFlows: PaginatedOrderFlowResponse;
	listOrders: PaginatedOrderResponse;
	listProductAddOns: PaginatedProductAddOnResponse;
	listProductLabels: PaginatedProductLabelResponse;
	listProducts: PaginatedProductResponse;
	listPromotionCarts: PaginatedPromotionCartResponse;
	listPromotionRequirements: PaginatedPromotionRequirementResponse;
	listPromotions: PaginatedPromotionResponse;
	listRoles: PaginatedRoleResponse;
	listTaxes: PaginatedTaxResponse;
	me?: Maybe<MeResponse>;
	myCart?: Maybe<Cart>;
	myPermissions: MyPermissionResult;
};

export type QueryGetBranchArgs = {
	id: Scalars["Int"];
};

export type QueryGetBranchProductArgs = {
	branchId: Scalars["Int"];
	productId: Scalars["Int"];
};

export type QueryGetCampaignArgs = {
	id: Scalars["Int"];
};

export type QueryGetCartArgs = {
	id: Scalars["Int"];
};

export type QueryGetCartProductArgs = {
	id: Scalars["Int"];
};

export type QueryGetCategoryArgs = {
	id: Scalars["Int"];
};

export type QueryGetCouponArgs = {
	id: Scalars["Int"];
};

export type QueryGetCustomerArgs = {
	id: Scalars["String"];
};

export type QueryGetFeatureToggleArgs = {
	id: Scalars["Int"];
};

export type QueryGetMembershipArgs = {
	id: Scalars["Int"];
};

export type QueryGetMembershipPartnerArgs = {
	partnerId: Scalars["Int"];
};

export type QueryGetModifierGroupArgs = {
	id: Scalars["Int"];
};

export type QueryGetOrderArgs = {
	id: Scalars["Int"];
};

export type QueryGetProductArgs = {
	branchId?: InputMaybe<Scalars["Int"]>;
	couponCode?: InputMaybe<Scalars["String"]>;
	id: Scalars["Int"];
};

export type QueryGetProductAddOnArgs = {
	id: Scalars["Int"];
};

export type QueryGetProductLabelArgs = {
	id: Scalars["Int"];
};

export type QueryGetPromotionArgs = {
	id: Scalars["Int"];
};

export type QueryGetTaxArgs = {
	id: Scalars["Int"];
};

export type QueryGetUserMembershipArgs = {
	membershipNumber?: InputMaybe<Scalars["String"]>;
};

export type QueryListActiveCampaignsArgs = {
	branchId: Scalars["Int"];
	discountLevel?: InputMaybe<Scalars["Int"]>;
};

export type QueryListActiveCategoriesArgs = {
	orderBy?: InputMaybe<ProductCategoryOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ProductCategoryWhereInput>;
};

export type QueryListAuditLogsArgs = {
	orderBy?: InputMaybe<AuditLogOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<AuditLogWhereInput>;
};

export type QueryListBranchProductsArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<BranchProductWhereInput>;
};

export type QueryListBranchesArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<BranchWhereInput>;
};

export type QueryListCampaignsArgs = {
	orderBy?: InputMaybe<CampaignOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<CampaignWhereInput>;
};

export type QueryListCartProductsArgs = {
	orderBy?: InputMaybe<CartProductOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<CartProductWhereInput>;
};

export type QueryListCartsArgs = {
	orderBy?: InputMaybe<CartOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<CartWhereInput>;
};

export type QueryListCategoriesArgs = {
	orderBy?: InputMaybe<ProductCategoryOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ProductCategoryWhereInput>;
};

export type QueryListCouponsArgs = {
	orderBy?: InputMaybe<CouponOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<CouponWhereInput>;
};

export type QueryListCustomersArgs = {
	orderBy?: InputMaybe<UserOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<UserWhereInput>;
};

export type QueryListFeatureTogglesArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<FeatureToggleWhereInput>;
};

export type QueryListFileLogsArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<FileLogWhereInput>;
};

export type QueryListMembershipArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<MembershipWhereInput>;
};

export type QueryListMembershipPartnerArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<MembershipPartnerWhereInput>;
};

export type QueryListMenuSectionsArgs = {
	branchId: Scalars["Int"];
	couponCode?: InputMaybe<Scalars["String"]>;
};

export type QueryListModifierGroupsArgs = {
	orderBy?: InputMaybe<ModifierGroupOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ModifierGroupWhereInput>;
};

export type QueryListOrderFlowsArgs = {
	orderBy?: InputMaybe<OrderByInputOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<OrderFlowWhereInput>;
};

export type QueryListOrdersArgs = {
	orderBy?: InputMaybe<OrderOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<OrderWhereInput>;
};

export type QueryListProductAddOnsArgs = {
	orderBy?: InputMaybe<ProductAddOnOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ProductAddOnWhereInput>;
};

export type QueryListProductLabelsArgs = {
	orderBy?: InputMaybe<ProductLabelOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ProductLabelWhereInput>;
};

export type QueryListProductsArgs = {
	orderBy?: InputMaybe<ProductOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<ProductWhereInput>;
};

export type QueryListPromotionCartsArgs = {
	orderBy?: InputMaybe<PromotionCartOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<PromotionCartWhereInput>;
};

export type QueryListPromotionRequirementsArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
};

export type QueryListPromotionsArgs = {
	orderBy?: InputMaybe<PromotionOrderByInput>;
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<PromotionWhereInput>;
};

export type QueryListTaxesArgs = {
	skip?: InputMaybe<Scalars["Int"]>;
	take?: InputMaybe<Scalars["Int"]>;
	where?: InputMaybe<TaxWhereInput>;
};

export type QueryMeArgs = {
	isAdmin?: InputMaybe<Scalars["Boolean"]>;
};

export type QueryMyPermissionsArgs = {
	isAdmin?: InputMaybe<Scalars["Boolean"]>;
};

export type RegisterError = {
	__typename?: "RegisterError";
	message: Scalars["String"];
};

export type RegisterInput = {
	couponCode?: InputMaybe<Scalars["String"]>;
	email: Scalars["String"];
	firstName: Scalars["String"];
	lastName: Scalars["String"];
	password: Scalars["String"];
	phone: Scalars["String"];
	referralCode?: InputMaybe<Scalars["String"]>;
};

export type RegisterResult = RegisterError | User;

export type RequirementIdProductId = {
	productId: Scalars["Int"];
	requirementId: Scalars["Int"];
};

export type ResetPasswordInput = {
	newPassword?: InputMaybe<Scalars["String"]>;
	tokenForgotPassword?: InputMaybe<Scalars["String"]>;
};

export type ResetPasswordResponse = {
	__typename?: "ResetPasswordResponse";
	message?: Maybe<Scalars["String"]>;
};

export type ResultFile = {
	__typename?: "ResultFile";
	file: File;
	status: Scalars["Int"];
};

export type RewardIdProductId = {
	productId: Scalars["Int"];
	rewardId: Scalars["Int"];
};

export type Role = {
	__typename?: "Role";
	description?: Maybe<Scalars["String"]>;
	id: Scalars["Int"];
	name: Scalars["String"];
};

export type SaveTokenResponse = {
	__typename?: "SaveTokenResponse";
	message: Scalars["String"];
};

export type Shipping = {
	__typename?: "Shipping";
	createdAt: Scalars["DateTime"];
	id: Scalars["Int"];
	shippingOrderNo?: Maybe<Scalars["String"]>;
	updatedAt: Scalars["DateTime"];
};

export type Shop = {
	__typename?: "Shop";
	id: Scalars["BigInt"];
	name: Scalars["String"];
};

export enum SortOrder {
	Asc = "asc",
	Desc = "desc",
}

export type StringFilter = {
	contains?: InputMaybe<Scalars["String"]>;
	endsWith?: InputMaybe<Scalars["String"]>;
	equals?: InputMaybe<Scalars["String"]>;
	gt?: InputMaybe<Scalars["String"]>;
	gte?: InputMaybe<Scalars["String"]>;
	in?: InputMaybe<Array<Scalars["String"]>>;
	lt?: InputMaybe<Scalars["String"]>;
	lte?: InputMaybe<Scalars["String"]>;
	notIn?: InputMaybe<Array<Scalars["String"]>>;
	startsWith?: InputMaybe<Scalars["String"]>;
};

export type SubCartProduct = {
	__typename?: "SubCartProduct";
	cartProductId: Scalars["Int"];
	connectionType: SubCartProductConnectionType;
	id: Scalars["Int"];
	mealItemCategory?: Maybe<MealItemCategory>;
	product: Product;
	productId: Scalars["Int"];
};

export enum SubCartProductConnectionType {
	Choice = "CHOICE",
	Fixed = "FIXED",
}

export type Tax = {
	__typename?: "Tax";
	branches: Array<Branch>;
	id: Scalars["Int"];
	name: Scalars["String"];
	percentage: Scalars["Int"];
};

export enum TaxType {
	AfterDiscount = "AFTER_DISCOUNT",
	BeforeDiscount = "BEFORE_DISCOUNT",
}

export type TaxWhereInput = {
	id?: InputMaybe<IntFilter>;
	name?: InputMaybe<StringFilter>;
};

export type Transaction = {
	__typename?: "Transaction";
	amount: Scalars["Int"];
	id: Scalars["String"];
	metadata?: Maybe<Scalars["JSONObject"]>;
	mode: Scalars["String"];
	status: TransactionStatus;
};

export enum TransactionStatus {
	Cancelled = "cancelled",
	Failed = "failed",
	New = "new",
	Success = "success",
}

export type UpdateBranchInput = {
	address?: InputMaybe<Scalars["String"]>;
	city?: InputMaybe<Scalars["String"]>;
	countryCode?: InputMaybe<Scalars["String"]>;
	googleMapLink?: InputMaybe<Scalars["String"]>;
	latitude?: InputMaybe<Scalars["String"]>;
	longitude?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	operatingTimes?: InputMaybe<Array<CreateOperatingTimeInput>>;
	phone?: InputMaybe<Scalars["String"]>;
	postalCode?: InputMaybe<Scalars["String"]>;
	region?: InputMaybe<Scalars["String"]>;
	taxType?: InputMaybe<TaxType>;
	timezone?: InputMaybe<Scalars["String"]>;
};

export type UpdateBranchProductInput = {
	branchId: Scalars["Int"];
	modifierGroupIds?: InputMaybe<Array<Scalars["Int"]>>;
	orderFlowIds?: InputMaybe<Array<Scalars["Int"]>>;
	position: Scalars["Int"];
	price: Scalars["Int"];
	status: Scalars["Int"];
	validFrom: Scalars["Int"];
	validUntil?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCampaignBranchInput = {
	branchId: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateCampaignInput = {
	campaignBranches: Array<UpdateCampaignBranchInput>;
	description: Scalars["String"];
	discountUnit: Scalars["Int"];
	discountValue: Scalars["Int"];
	endAt: Scalars["Int"];
	id: Scalars["Int"];
	name: Scalars["String"];
	startAt: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateCartProductInput = {
	productAddOnIds?: InputMaybe<Array<Scalars["Int"]>>;
	quantity?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<CartProductStatus>;
	subProducts?: InputMaybe<Array<UpdateSubCartProductInput>>;
};

export type UpdateCategoryInput = {
	extraData?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	position?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<Scalars["Int"]>;
	validFrom?: InputMaybe<Scalars["Int"]>;
	validUntil?: InputMaybe<Scalars["Int"]>;
};

export type UpdateCouponInput = {
	couponBranchProducts: Array<UpdateCouponInputBranchProducts>;
	description?: InputMaybe<Scalars["String"]>;
	id: Scalars["Int"];
	maxQuota?: InputMaybe<Scalars["Int"]>;
	status?: InputMaybe<Scalars["Int"]>;
	userEmail?: InputMaybe<Scalars["String"]>;
	userName?: InputMaybe<Scalars["String"]>;
	userPhone?: InputMaybe<Scalars["String"]>;
};

export type UpdateCouponInputBranchProducts = {
	branchProductId: Scalars["Int"];
	discountValue: Scalars["Int"];
	quantity: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateMembershipInput = {
	id: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateMembershipPartnerInput = {
	description?: InputMaybe<Scalars["String"]>;
	discounts?: InputMaybe<Array<MembershipDiscountInput>>;
	inherit_discounts_from_global_settings?: InputMaybe<Scalars["Boolean"]>;
	name?: InputMaybe<Scalars["String"]>;
	partnerId: Scalars["Int"];
	status?: InputMaybe<Scalars["Int"]>;
};

export type UpdateModifierGroupInput = {
	branchId: Scalars["Int"];
	description: Scalars["String"];
	maxQuantity: Scalars["Int"];
	minQuantity: Scalars["Int"];
	modifiers?: InputMaybe<Array<CreateOrUpdateModifierInput>>;
	name: Scalars["String"];
	position: Scalars["Int"];
	status: Scalars["Int"];
	type: Scalars["Int"];
};

export type UpdateModifierInput = {
	id: Scalars["Int"];
	price: Scalars["Int"];
	ref: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateOrderInput = {
	status?: InputMaybe<OrderStatus>;
	transaction?: InputMaybe<UpdateTransactionInput>;
};

export type UpdateProductAddOnInput = {
	description?: InputMaybe<Scalars["String"]>;
	image?: InputMaybe<Scalars["String"]>;
	name?: InputMaybe<Scalars["String"]>;
	price?: InputMaybe<Scalars["Int"]>;
};

export type UpdateProductInput = {
	branchProducts?: InputMaybe<Array<UpdateBranchProductInput>>;
	categoryId?: InputMaybe<Scalars["Int"]>;
	description?: InputMaybe<Scalars["String"]>;
	image?: InputMaybe<Scalars["String"]>;
	imageUpload?: InputMaybe<Scalars["Upload"]>;
	mealItemCategories?: InputMaybe<Array<CreateMealItemCategory>>;
	mealItemProducts?: InputMaybe<Array<CreateMealItemProduct>>;
	name?: InputMaybe<Scalars["String"]>;
	productAddOnIds?: InputMaybe<Array<Scalars["Int"]>>;
	productLabels?: InputMaybe<Array<UpdateProductProductLabelInput>>;
};

export type UpdateProductLabelInput = {
	name?: InputMaybe<Scalars["String"]>;
};

export type UpdateProductProductLabelInput = {
	product_label_id: Scalars["Int"];
	status: Scalars["Int"];
};

export type UpdateProfileInput = {
	email?: InputMaybe<Scalars["String"]>;
	firstName?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	phone?: InputMaybe<Scalars["String"]>;
};

export type UpdatePromotionCartInput = {
	quantity?: InputMaybe<Scalars["Int"]>;
	requirementIdProductIds?: InputMaybe<Array<RequirementIdProductId>>;
	rewardIdProductIds?: InputMaybe<Array<RewardIdProductId>>;
	status?: InputMaybe<PromotionCartStatus>;
};

export type UpdatePromotionInput = {
	branchIds?: InputMaybe<Array<Scalars["Int"]>>;
	imageUpload?: InputMaybe<Scalars["Upload"]>;
	name?: InputMaybe<Scalars["String"]>;
	requirements?: InputMaybe<Array<CreatePromotionRequirementInput>>;
	rewards?: InputMaybe<Array<CreatePromotionRewardInput>>;
	validFrom?: InputMaybe<Scalars["Date"]>;
	validUntil?: InputMaybe<Scalars["Date"]>;
};

export type UpdateSubCartProductInput = {
	id: Scalars["Int"];
	productId: Scalars["Int"];
};

export type UpdateTaxInput = {
	branchIds?: InputMaybe<Array<Scalars["Int"]>>;
	name?: InputMaybe<Scalars["String"]>;
	percentage?: InputMaybe<Scalars["Int"]>;
};

export type UpdateTransactionInput = {
	status?: InputMaybe<TransactionStatus>;
};

export type User = {
	__typename?: "User";
	countryCode?: Maybe<Scalars["String"]>;
	createdAt: Scalars["DateTime"];
	email?: Maybe<Scalars["String"]>;
	firstName: Scalars["String"];
	id: Scalars["String"];
	lastName: Scalars["String"];
	lastSignInAt?: Maybe<Scalars["DateTime"]>;
	phone?: Maybe<Scalars["String"]>;
	updatedAt: Scalars["DateTime"];
};

export type UserOrderByInput = {
	email?: InputMaybe<SortOrder>;
};

export type UserWhereInput = {
	email?: InputMaybe<StringFilter>;
	id?: InputMaybe<StringFilter>;
};

export type ValidateCouponInput = {
	branchId: Scalars["Int"];
	couponCode: Scalars["String"];
};

export type ValidateCouponResponse = {
	__typename?: "validateCouponResponse";
	coupon?: Maybe<CouponWithCampaign>;
	error: Scalars["String"];
};

export type GetUserMembershipQueryVariables = Exact<{
	membershipNumber?: InputMaybe<Scalars["String"]>;
}>;

export type GetUserMembershipQuery = {
	__typename?: "Query";
	getUserMembership: {
		__typename?: "GetUserMembershipResponse";
		qr: string;
		membershipNumber: string;
		membershipPartnerName: string;
		referralFrom: string;
		isReferralFromUsable: boolean;
		referralFromUnusableReason: string;
		referralCode: string;
		isReferralUsable: boolean;
		referralUnusableReason: string;
		isActive: boolean;
		discounts: Array<{
			__typename?: "MembershipDiscount";
			name: string;
			unit: number;
			value: number;
			isReferral: boolean;
		}>;
		referralDiscount?: {
			__typename?: "MembershipDiscount";
			name: string;
			unit: number;
			value: number;
			isReferral: boolean;
		} | null;
	};
};

export type LoginMutationVariables = Exact<{
	input: LoginInput;
}>;

export type LoginMutation = {
	__typename?: "Mutation";
	login: {
		__typename?: "LoginResponse";
		message?: string | null;
		user?: { __typename?: "User"; email?: string | null } | null;
	};
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: "Mutation"; logout: boolean };

export type RegisterMutationVariables = Exact<{
	input: RegisterInput;
}>;

export type RegisterMutation = {
	__typename?: "Mutation";
	register:
		| { __typename?: "RegisterError"; message: string }
		| { __typename?: "User"; email?: string | null };
};

export type ForgotPasswordMutationVariables = Exact<{
	input?: InputMaybe<ForgotPasswordInput>;
}>;

export type ForgotPasswordMutation = {
	__typename?: "Mutation";
	forgotPassword: {
		__typename?: "ForgotPasswordResponse";
		success?: boolean | null;
		message?: string | null;
	};
};

export type IsForgotPasswordTokenValidMutationVariables = Exact<{
	input?: InputMaybe<IsForgotPasswordTokenValidInput>;
}>;

export type IsForgotPasswordTokenValidMutation = {
	__typename?: "Mutation";
	isForgotPasswordTokenValid: {
		__typename?: "IsForgotPasswordTokenValidResponse";
		success?: boolean | null;
		message?: string | null;
	};
};

export type ResetPasswordMutationVariables = Exact<{
	input?: InputMaybe<ResetPasswordInput>;
}>;

export type ResetPasswordMutation = {
	__typename?: "Mutation";
	resetPassword: {
		__typename?: "ResetPasswordResponse";
		message?: string | null;
	};
};

export type UpdateProfileMutationVariables = Exact<{
	values: UpdateProfileInput;
}>;

export type UpdateProfileMutation = {
	__typename?: "Mutation";
	updateProfile: { __typename?: "User"; email?: string | null };
};

export type CreateConfirmationMutationVariables = Exact<{
	input: CreateConfirmationInput;
}>;

export type CreateConfirmationMutation = {
	__typename?: "Mutation";
	createConfirmation: {
		__typename?: "CreateConfirmationResponse";
		success: boolean;
		message?: string | null;
		phone?: string | null;
		email?: string | null;
	};
};

export type ConfirmPhoneMutationVariables = Exact<{
	otp: Scalars["String"];
}>;

export type ConfirmPhoneMutation = {
	__typename?: "Mutation";
	confirmPhone: {
		__typename?: "ConfirmPhoneResponse";
		success: boolean;
		message?: string | null;
	};
};

export type ConfirmEmailMutationVariables = Exact<{
	token: Scalars["String"];
}>;

export type ConfirmEmailMutation = {
	__typename?: "Mutation";
	confirmEmail: {
		__typename?: "ConfirmEmailResponse";
		success: boolean;
		message?: string | null;
	};
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
	__typename?: "Query";
	me?: {
		__typename?: "MeResponse";
		id: string;
		firstName: string;
		lastName: string;
		email?: string | null;
		countryCode?: string | null;
		phone?: string | null;
		couponCode?: string | null;
	} | null;
};

export type ListBranchesQueryVariables = Exact<{
	where?: InputMaybe<BranchWhereInput>;
}>;

export type ListBranchesQuery = {
	__typename?: "Query";
	listBranches: {
		__typename?: "PaginatedBranchResponse";
		edges: Array<{
			__typename?: "Branch";
			id: number;
			name: string;
			address: string;
			timezone: string;
			operatingTimes: Array<{
				__typename?: "OperatingTime";
				id: number;
				closeTime: string;
				openTime: string;
				dayOfWeek: number;
			}>;
			taxes: Array<{
				__typename?: "Tax";
				id: number;
				name: string;
				percentage: number;
			}>;
		}>;
	};
};

export type ListBranchesNameQueryVariables = Exact<{ [key: string]: never }>;

export type ListBranchesNameQuery = {
	__typename?: "Query";
	listBranches: {
		__typename?: "PaginatedBranchResponse";
		edges: Array<{
			__typename?: "Branch";
			id: number;
			name: string;
			address: string;
		}>;
	};
};

export type GetBranchQueryVariables = Exact<{
	id: Scalars["Int"];
}>;

export type GetBranchQuery = {
	__typename?: "Query";
	getBranch: {
		__typename?: "Branch";
		id: number;
		name: string;
		address: string;
		latitude: string;
		longitude: string;
	};
};

export type ListActiveCampaignsQueryVariables = Exact<{
	branchId: Scalars["Int"];
	discountLevel?: InputMaybe<Scalars["Int"]>;
}>;

export type ListActiveCampaignsQuery = {
	__typename?: "Query";
	listActiveCampaigns: Array<{
		__typename?: "Campaign";
		id: any;
		name: string;
		description: string;
		startAt: number;
		endAt: number;
	}>;
};

export type CartProductIdFragment = {
	__typename?: "CartProduct";
	productId: number;
	cartId: number;
};

export type DeleteCartProductMutationVariables = Exact<{
	id: Scalars["Int"];
}>;

export type DeleteCartProductMutation = {
	__typename?: "Mutation";
	deleteCartProduct: { __typename?: "CartProduct"; id: number };
};

export type UpdateCartProductMutationVariables = Exact<{
	id: Scalars["Int"];
	values: UpdateCartProductInput;
}>;

export type UpdateCartProductMutation = {
	__typename?: "Mutation";
	updateCartProduct: {
		__typename?: "CartProduct";
		id: number;
		cartId: number;
		productId: number;
		quantity: number;
		status: CartProductStatus;
		addons: Array<{
			__typename?: "CartProductProductAddOn";
			cartProductId: number;
			productAddOnId: number;
			productAddOn: {
				__typename?: "ProductAddOn";
				id: number;
				name: string;
				price: number;
			};
		}>;
		product: {
			__typename?: "Product";
			id: number;
			name: string;
			image?: string | null;
			price: number;
			addons?: Array<{
				__typename?: "ProductAddOn";
				id: number;
				name: string;
				price: number;
			}> | null;
		};
	};
};

export type AddProductToCartWithAddOnsMutationVariables = Exact<{
	productId: Scalars["Int"];
	branchId: Scalars["Int"];
	orderFlowId: Scalars["Int"];
	name: Scalars["String"];
	price: Scalars["Int"];
	quantity?: InputMaybe<Scalars["Int"]>;
	productAddOnIds: Array<Scalars["Int"]> | Scalars["Int"];
	subProducts:
		| Array<CreateSubCartProductWithoutCartProductInput>
		| CreateSubCartProductWithoutCartProductInput;
	coupon?: InputMaybe<AddProductToCartCoupon>;
}>;

export type AddProductToCartWithAddOnsMutation = {
	__typename?: "Mutation";
	addProductToCartWithAddOns: {
		__typename?: "CartProduct";
		id: number;
		cartId: number;
		productId: number;
		quantity: number;
		status: CartProductStatus;
		product: {
			__typename?: "Product";
			id: number;
			name: string;
			image?: string | null;
			price: number;
		};
	};
};

export type GetActiveCartProductQueryVariables = Exact<{
	[key: string]: never;
}>;

export type GetActiveCartProductQuery = {
	__typename?: "Query";
	getActiveCartProduct: Array<{
		__typename?: "CartProduct";
		id: number;
		quantity: number;
		productId: number;
		cartId: number;
		product: {
			__typename?: "Product";
			id: number;
			name: string;
			slug: string;
			price: number;
			image?: string | null;
			cloudinaryPublicId?: string | null;
			addons?: Array<{
				__typename?: "ProductAddOn";
				id: number;
				name: string;
				price: number;
			}> | null;
		};
		addons: Array<{
			__typename?: "CartProductProductAddOn";
			cartProductId: number;
			productAddOnId: number;
			productAddOn: {
				__typename?: "ProductAddOn";
				id: number;
				name: string;
				price: number;
			};
		}>;
	}>;
};

export type GetActiveCartProductBaseQueryVariables = Exact<{
	[key: string]: never;
}>;

export type GetActiveCartProductBaseQuery = {
	__typename?: "Query";
	getActiveCartProduct: Array<{
		__typename?: "CartProduct";
		quantity: number;
		productId: number;
		cartId: number;
	}>;
};

export type ClearCartMutationVariables = Exact<{ [key: string]: never }>;

export type ClearCartMutation = { __typename?: "Mutation"; clearCart: string };

export type DeleteAndClearCartMutationVariables = Exact<{
	[key: string]: never;
}>;

export type DeleteAndClearCartMutation = {
	__typename?: "Mutation";
	deleteAndClearCart: boolean;
};

export type MyCartQueryVariables = Exact<{ [key: string]: never }>;

export type MyCartQuery = {
	__typename?: "Query";
	myCart?: { __typename?: "Cart"; id: number } | null;
};

export type MyCartTotalItemsQueryVariables = Exact<{ [key: string]: never }>;

export type MyCartTotalItemsQuery = {
	__typename?: "Query";
	myCart?: { __typename?: "Cart"; id: number; totalItems: number } | null;
};

export type MyCartItemsQueryVariables = Exact<{ [key: string]: never }>;

export type MyCartItemsQuery = {
	__typename?: "Query";
	myCart?: {
		__typename?: "Cart";
		id: number;
		totalProductsPrice: number;
		promotionCarts: Array<{
			__typename?: "PromotionCart";
			id: number;
			quantity: number;
			promotion: {
				__typename?: "Promotion";
				id: number;
				name: string;
				cloudinaryPublicId?: string | null;
				rewards: Array<{
					__typename?: "PromotionReward";
					discountUnit?: DiscountUnit | null;
					discountValue?: number | null;
				}>;
			};
			promotionCartsOnProducts: Array<{
				__typename?: "PromotionCartOnProducts";
				quantity: number;
				connectionType: PromotionToProductConnectionType;
				promotionRequirementId?: number | null;
				promotionRewardId?: number | null;
				product: {
					__typename?: "Product";
					id: number;
					name: string;
					price: number;
				};
			}>;
		}>;
		productConnection: Array<{
			__typename?: "CartProduct";
			id: number;
			quantity: number;
			extraData: string;
			price: number;
			product: {
				__typename?: "Product";
				id: number;
				name: string;
				slug: string;
				price: number;
				image?: string | null;
				cloudinaryPublicId?: string | null;
				addons?: Array<{
					__typename?: "ProductAddOn";
					id: number;
					name: string;
					price: number;
				}> | null;
			};
			addons: Array<{
				__typename?: "CartProductProductAddOn";
				cartProductId: number;
				productAddOnId: number;
				productAddOn: {
					__typename?: "ProductAddOn";
					id: number;
					name: string;
					price: number;
				};
			}>;
			subCartProducts: Array<{
				__typename?: "SubCartProduct";
				id: number;
				product: { __typename?: "Product"; id: number; name: string };
				mealItemCategory?: {
					__typename?: "MealItemCategory";
					id: number;
					quantity: number;
					category: {
						__typename?: "ProductCategory";
						id: number;
						name: string;
					};
				} | null;
			}>;
		}>;
	} | null;
};

export type MyCartItemIdsQueryVariables = Exact<{ [key: string]: never }>;

export type MyCartItemIdsQuery = {
	__typename?: "Query";
	myCart?: {
		__typename?: "Cart";
		promotionCarts: Array<{
			__typename?: "PromotionCart";
			promotionId: number;
			quantity: number;
		}>;
		productConnection: Array<{
			__typename?: "CartProduct";
			quantity: number;
			productId: number;
			extraData: string;
		}>;
	} | null;
};

export type ListCategoriesWithProductsQueryVariables = Exact<{
	[key: string]: never;
}>;

export type ListCategoriesWithProductsQuery = {
	__typename?: "Query";
	listCategories: {
		__typename?: "PaginatedProductCategoryResponse";
		edges: Array<{
			__typename?: "ProductCategory";
			id: number;
			name: string;
			products: Array<{
				__typename?: "Product";
				id: number;
				name: string;
				price: number;
			}>;
		}>;
	};
};

export type ValidateCouponMutationVariables = Exact<{
	input: ValidateCouponInput;
}>;

export type ValidateCouponMutation = {
	__typename?: "Mutation";
	validateCoupon: {
		__typename?: "validateCouponResponse";
		error: string;
		coupon?: {
			__typename?: "CouponWithCampaign";
			code: string;
			userName: string;
			discountLevel: number;
		} | null;
	};
};

export type OrderHistoryQueryVariables = Exact<{ [key: string]: never }>;

export type OrderHistoryQuery = {
	__typename?: "Query";
	historyOrders: Array<{
		__typename?: "HistoryOrder";
		id: number;
		code: string;
		status: OrderStatus;
		createdAt: any;
		scheduledAt: number;
		branch: { __typename?: "Branch"; name: string };
		snapshot?: {
			__typename?: "OrderSnapshot";
			order_flow: string;
			notes: string;
			fee_breakdown: {
				__typename?: "OrderSnapshotFeeBreakdown";
				subtotal: number;
				fees: Array<{
					__typename?: "OrderSnapshotFee";
					name: string;
					value: number;
					percentage: number;
				}>;
				discounts: Array<{
					__typename?: "OrderSnapshotDiscount";
					name: string;
					value: number;
					unit: number;
					price: number;
				}>;
				taxes: Array<{
					__typename?: "OrderSnapshotTax";
					name: string;
					value: number;
					percentage: number;
				}>;
			};
			items: Array<{
				__typename?: "OrderSnapshotItem";
				product_id: number;
				name: string;
				quantity: number;
				price: number;
				modifiers?: Array<{
					__typename?: "OrderSnapshotItemModifier";
					cart_modifier_id: number;
					modifier_id: number;
					name: string;
					price: number;
					quantity: number;
				}> | null;
				coupon?: {
					__typename?: "OrderSnapshotCoupon";
					code: string;
					discount_value: number;
					original_price: number;
				} | null;
			}>;
		} | null;
	}>;
};

export type CheckoutMutationVariables = Exact<{
	input: CheckoutInput;
}>;

export type CheckoutMutation = {
	__typename?: "Mutation";
	checkout: {
		__typename?: "CheckoutResponse";
		invoiceUrl?: string | null;
		order: { __typename?: "Order"; code: string };
	};
};

export type ListProductsQueryVariables = Exact<{
	take: Scalars["Int"];
}>;

export type ListProductsQuery = {
	__typename?: "Query";
	listProducts: {
		__typename?: "PaginatedProductResponse";
		edges: Array<{
			__typename?: "Product";
			id: number;
			name: string;
			slug: string;
			description?: string | null;
			image?: string | null;
			cloudinaryPublicId?: string | null;
			price: number;
			category?: {
				__typename?: "ProductCategory";
				id: number;
				name: string;
			} | null;
			labels?: Array<{
				__typename?: "ProductLabel";
				id: number;
				name: string;
			}> | null;
		}>;
	};
};

export type GetProductQueryVariables = Exact<{
	id: Scalars["Int"];
	branchId: Scalars["Int"];
	couponCode?: InputMaybe<Scalars["String"]>;
}>;

export type GetProductQuery = {
	__typename?: "Query";
	getProduct:
		| {
				__typename?: "Product";
				id: number;
				name: string;
				slug: string;
				description?: string | null;
				image?: string | null;
				cloudinaryPublicId?: string | null;
				price: number;
				addons?: Array<{
					__typename?: "ProductAddOn";
					id: number;
					name: string;
					price: number;
				}> | null;
				labels?: Array<{
					__typename?: "ProductLabel";
					id: number;
					name: string;
				}> | null;
				mealItemProducts: Array<{
					__typename?: "MealItemProduct";
					quantity: number;
					childProduct: { __typename?: "Product"; id: number; name: string };
				}>;
				coupon?: {
					__typename?: "ProductCoupon";
					code: string;
					discountValue: number;
					quantity: number;
				} | null;
				mealItemCategories: Array<{
					__typename?: "MealItemCategory";
					id: number;
					quantity: number;
					category: {
						__typename?: "ProductCategory";
						id: number;
						name: string;
					};
				}>;
		  }
		| { __typename?: "ProductNotFound" };
};

export type ListMenuSectionsQueryVariables = Exact<{
	branchId: Scalars["Int"];
	couponCode?: InputMaybe<Scalars["String"]>;
}>;

export type ListMenuSectionsQuery = {
	__typename?: "Query";
	listMenuSections: {
		__typename?: "AllMenuSection";
		special: Array<{
			__typename?: "MenuSection";
			id: number;
			name: string;
			position: number;
			items?: Array<{
				__typename?: "MenuSectionItem";
				id: number;
				name: string;
				image: string;
				cloudinaryPublicId?: string | null;
				slug: string;
				description?: string | null;
				position: number;
				price: number;
				labels?: Array<{
					__typename?: "MenuSectionItemLabel";
					id: number;
					name: string;
					position: number;
				}> | null;
				coupon?: {
					__typename?: "MealItemCoupon";
					code: string;
					discountValue: number;
				} | null;
			}> | null;
		}>;
		main: Array<{
			__typename?: "MenuSection";
			id: number;
			name: string;
			position: number;
			items?: Array<{
				__typename?: "MenuSectionItem";
				id: number;
				name: string;
				image: string;
				cloudinaryPublicId?: string | null;
				slug: string;
				description?: string | null;
				position: number;
				price: number;
				labels?: Array<{
					__typename?: "MenuSectionItemLabel";
					id: number;
					name: string;
					position: number;
				}> | null;
			}> | null;
		}>;
	};
};

export type AddPromotionToCartMutationVariables = Exact<{
	values: AddPromotionToCartInput;
}>;

export type AddPromotionToCartMutation = {
	__typename?: "Mutation";
	addPromotionToCart: { __typename?: "PromotionCart"; id: number };
};

export type UpdatePromotionCartMutationVariables = Exact<{
	id: Scalars["Int"];
	values: UpdatePromotionCartInput;
}>;

export type UpdatePromotionCartMutation = {
	__typename?: "Mutation";
	updatePromotionCart: {
		__typename?: "PromotionCart";
		id: number;
		quantity: number;
	};
};

export type DeletePromotionCartMutationVariables = Exact<{
	id: Scalars["Int"];
}>;

export type DeletePromotionCartMutation = {
	__typename?: "Mutation";
	deletePromotionCart: { __typename?: "PromotionCart"; id: number };
};

export type ListPromotionsQueryVariables = Exact<{
	where?: InputMaybe<PromotionWhereInput>;
}>;

export type ListPromotionsQuery = {
	__typename?: "Query";
	listPromotions: {
		__typename?: "PaginatedPromotionResponse";
		edges: Array<{
			__typename?: "Promotion";
			id: number;
			name: string;
			validFrom: any;
			validUntil: any;
			image: string;
			cloudinaryPublicId?: string | null;
		}>;
	};
};

export type GetPromotionQueryVariables = Exact<{
	id: Scalars["Int"];
}>;

export type GetPromotionQuery = {
	__typename?: "Query";
	getPromotion: {
		__typename?: "Promotion";
		id: number;
		name: string;
		validFrom: any;
		validUntil: any;
		image: string;
		cloudinaryPublicId?: string | null;
		requirements: Array<{
			__typename?: "PromotionRequirement";
			id: number;
			quantity: number;
			productId?: number | null;
			categoryId?: number | null;
			product?: { __typename?: "Product"; name: string } | null;
			category?: { __typename?: "ProductCategory"; name: string } | null;
		}>;
		rewards: Array<{
			__typename?: "PromotionReward";
			id: number;
			quantity?: number | null;
			productId?: number | null;
			categoryId?: number | null;
			discountUnit?: DiscountUnit | null;
			discountValue?: number | null;
			product?: { __typename?: "Product"; id: number; name: string } | null;
			category?: {
				__typename?: "ProductCategory";
				id: number;
				name: string;
			} | null;
		}>;
	};
};

export type ListTaxesQueryVariables = Exact<{ [key: string]: never }>;

export type ListTaxesQuery = {
	__typename?: "Query";
	listTaxes: {
		__typename?: "PaginatedTaxResponse";
		edges: Array<{
			__typename?: "Tax";
			name: string;
			percentage: number;
			id: number;
		}>;
	};
};

export const CartProductIdFragmentDoc = `
    fragment CartProductID on CartProduct {
  productId
  cartId
}
    `;
export const GetUserMembershipDocument = `
    query GetUserMembership($membershipNumber: String) {
  getUserMembership(membershipNumber: $membershipNumber) {
    qr
    membershipNumber
    membershipPartnerName
    referralFrom
    isReferralFromUsable
    referralFromUnusableReason
    referralCode
    isReferralUsable
    referralUnusableReason
    isActive
    discounts {
      name
      unit
      value
      isReferral
    }
    referralDiscount {
      name
      unit
      value
      isReferral
    }
  }
}
    `;
export const useGetUserMembershipQuery = <
	TData = GetUserMembershipQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: GetUserMembershipQueryVariables,
	options?: UseQueryOptions<GetUserMembershipQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetUserMembershipQuery, TError, TData>(
		variables === undefined
			? ["GetUserMembership"]
			: ["GetUserMembership", variables],
		fetcher<GetUserMembershipQuery, GetUserMembershipQueryVariables>(
			client,
			GetUserMembershipDocument,
			variables,
			headers
		),
		options
	);
export const LoginDocument = `
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    user {
      email
    }
    message
  }
}
    `;
export const useLoginMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		LoginMutation,
		TError,
		LoginMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
		["Login"],
		(variables?: LoginMutationVariables) =>
			fetcher<LoginMutation, LoginMutationVariables>(
				client,
				LoginDocument,
				variables,
				headers
			)(),
		options
	);
export const LogoutDocument = `
    mutation Logout {
  logout
}
    `;
export const useLogoutMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		LogoutMutation,
		TError,
		LogoutMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
		["Logout"],
		(variables?: LogoutMutationVariables) =>
			fetcher<LogoutMutation, LogoutMutationVariables>(
				client,
				LogoutDocument,
				variables,
				headers
			)(),
		options
	);
export const RegisterDocument = `
    mutation Register($input: RegisterInput!) {
  register(input: $input) {
    ... on User {
      email
    }
    ... on RegisterError {
      message
    }
  }
}
    `;
export const useRegisterMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		RegisterMutation,
		TError,
		RegisterMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<RegisterMutation, TError, RegisterMutationVariables, TContext>(
		["Register"],
		(variables?: RegisterMutationVariables) =>
			fetcher<RegisterMutation, RegisterMutationVariables>(
				client,
				RegisterDocument,
				variables,
				headers
			)(),
		options
	);
export const ForgotPasswordDocument = `
    mutation ForgotPassword($input: ForgotPasswordInput) {
  forgotPassword(input: $input) {
    success
    message
  }
}
    `;
export const useForgotPasswordMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ForgotPasswordMutation,
		TError,
		ForgotPasswordMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		ForgotPasswordMutation,
		TError,
		ForgotPasswordMutationVariables,
		TContext
	>(
		["ForgotPassword"],
		(variables?: ForgotPasswordMutationVariables) =>
			fetcher<ForgotPasswordMutation, ForgotPasswordMutationVariables>(
				client,
				ForgotPasswordDocument,
				variables,
				headers
			)(),
		options
	);
export const IsForgotPasswordTokenValidDocument = `
    mutation IsForgotPasswordTokenValid($input: IsForgotPasswordTokenValidInput) {
  isForgotPasswordTokenValid(input: $input) {
    success
    message
  }
}
    `;
export const useIsForgotPasswordTokenValidMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		IsForgotPasswordTokenValidMutation,
		TError,
		IsForgotPasswordTokenValidMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		IsForgotPasswordTokenValidMutation,
		TError,
		IsForgotPasswordTokenValidMutationVariables,
		TContext
	>(
		["IsForgotPasswordTokenValid"],
		(variables?: IsForgotPasswordTokenValidMutationVariables) =>
			fetcher<
				IsForgotPasswordTokenValidMutation,
				IsForgotPasswordTokenValidMutationVariables
			>(client, IsForgotPasswordTokenValidDocument, variables, headers)(),
		options
	);
export const ResetPasswordDocument = `
    mutation ResetPassword($input: ResetPasswordInput) {
  resetPassword(input: $input) {
    message
  }
}
    `;
export const useResetPasswordMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ResetPasswordMutation,
		TError,
		ResetPasswordMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		ResetPasswordMutation,
		TError,
		ResetPasswordMutationVariables,
		TContext
	>(
		["ResetPassword"],
		(variables?: ResetPasswordMutationVariables) =>
			fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(
				client,
				ResetPasswordDocument,
				variables,
				headers
			)(),
		options
	);
export const UpdateProfileDocument = `
    mutation UpdateProfile($values: UpdateProfileInput!) {
  updateProfile(values: $values) {
    email
  }
}
    `;
export const useUpdateProfileMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		UpdateProfileMutation,
		TError,
		UpdateProfileMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		UpdateProfileMutation,
		TError,
		UpdateProfileMutationVariables,
		TContext
	>(
		["UpdateProfile"],
		(variables?: UpdateProfileMutationVariables) =>
			fetcher<UpdateProfileMutation, UpdateProfileMutationVariables>(
				client,
				UpdateProfileDocument,
				variables,
				headers
			)(),
		options
	);
export const CreateConfirmationDocument = `
    mutation CreateConfirmation($input: CreateConfirmationInput!) {
  createConfirmation(input: $input) {
    success
    message
    phone
    email
  }
}
    `;
export const useCreateConfirmationMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		CreateConfirmationMutation,
		TError,
		CreateConfirmationMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		CreateConfirmationMutation,
		TError,
		CreateConfirmationMutationVariables,
		TContext
	>(
		["CreateConfirmation"],
		(variables?: CreateConfirmationMutationVariables) =>
			fetcher<CreateConfirmationMutation, CreateConfirmationMutationVariables>(
				client,
				CreateConfirmationDocument,
				variables,
				headers
			)(),
		options
	);
export const ConfirmPhoneDocument = `
    mutation ConfirmPhone($otp: String!) {
  confirmPhone(otp: $otp) {
    success
    message
  }
}
    `;
export const useConfirmPhoneMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ConfirmPhoneMutation,
		TError,
		ConfirmPhoneMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		ConfirmPhoneMutation,
		TError,
		ConfirmPhoneMutationVariables,
		TContext
	>(
		["ConfirmPhone"],
		(variables?: ConfirmPhoneMutationVariables) =>
			fetcher<ConfirmPhoneMutation, ConfirmPhoneMutationVariables>(
				client,
				ConfirmPhoneDocument,
				variables,
				headers
			)(),
		options
	);
export const ConfirmEmailDocument = `
    mutation ConfirmEmail($token: String!) {
  confirmEmail(token: $token) {
    success
    message
  }
}
    `;
export const useConfirmEmailMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ConfirmEmailMutation,
		TError,
		ConfirmEmailMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		ConfirmEmailMutation,
		TError,
		ConfirmEmailMutationVariables,
		TContext
	>(
		["ConfirmEmail"],
		(variables?: ConfirmEmailMutationVariables) =>
			fetcher<ConfirmEmailMutation, ConfirmEmailMutationVariables>(
				client,
				ConfirmEmailDocument,
				variables,
				headers
			)(),
		options
	);
export const MeDocument = `
    query Me {
  me {
    id
    firstName
    lastName
    email
    countryCode
    phone
    couponCode
  }
}
    `;
export const useMeQuery = <TData = MeQuery, TError = unknown>(
	client: GraphQLClient,
	variables?: MeQueryVariables,
	options?: UseQueryOptions<MeQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<MeQuery, TError, TData>(
		variables === undefined ? ["Me"] : ["Me", variables],
		fetcher<MeQuery, MeQueryVariables>(client, MeDocument, variables, headers),
		options
	);
export const ListBranchesDocument = `
    query ListBranches($where: BranchWhereInput) {
  listBranches(where: $where) {
    edges {
      id
      name
      address
      timezone
      operatingTimes {
        id
        closeTime
        openTime
        dayOfWeek
      }
      taxes {
        id
        name
        percentage
      }
    }
  }
}
    `;
export const useListBranchesQuery = <
	TData = ListBranchesQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: ListBranchesQueryVariables,
	options?: UseQueryOptions<ListBranchesQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListBranchesQuery, TError, TData>(
		variables === undefined ? ["ListBranches"] : ["ListBranches", variables],
		fetcher<ListBranchesQuery, ListBranchesQueryVariables>(
			client,
			ListBranchesDocument,
			variables,
			headers
		),
		options
	);
export const ListBranchesNameDocument = `
    query ListBranchesName {
  listBranches {
    edges {
      id
      name
      address
    }
  }
}
    `;
export const useListBranchesNameQuery = <
	TData = ListBranchesNameQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: ListBranchesNameQueryVariables,
	options?: UseQueryOptions<ListBranchesNameQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListBranchesNameQuery, TError, TData>(
		variables === undefined
			? ["ListBranchesName"]
			: ["ListBranchesName", variables],
		fetcher<ListBranchesNameQuery, ListBranchesNameQueryVariables>(
			client,
			ListBranchesNameDocument,
			variables,
			headers
		),
		options
	);
export const GetBranchDocument = `
    query GetBranch($id: Int!) {
  getBranch(id: $id) {
    id
    name
    address
    latitude
    longitude
  }
}
    `;
export const useGetBranchQuery = <TData = GetBranchQuery, TError = unknown>(
	client: GraphQLClient,
	variables: GetBranchQueryVariables,
	options?: UseQueryOptions<GetBranchQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetBranchQuery, TError, TData>(
		["GetBranch", variables],
		fetcher<GetBranchQuery, GetBranchQueryVariables>(
			client,
			GetBranchDocument,
			variables,
			headers
		),
		options
	);
export const ListActiveCampaignsDocument = `
    query ListActiveCampaigns($branchId: Int!, $discountLevel: Int) {
  listActiveCampaigns(branchId: $branchId, discountLevel: $discountLevel) {
    id
    name
    description
    startAt
    endAt
  }
}
    `;
export const useListActiveCampaignsQuery = <
	TData = ListActiveCampaignsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables: ListActiveCampaignsQueryVariables,
	options?: UseQueryOptions<ListActiveCampaignsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListActiveCampaignsQuery, TError, TData>(
		["ListActiveCampaigns", variables],
		fetcher<ListActiveCampaignsQuery, ListActiveCampaignsQueryVariables>(
			client,
			ListActiveCampaignsDocument,
			variables,
			headers
		),
		options
	);
export const DeleteCartProductDocument = `
    mutation DeleteCartProduct($id: Int!) {
  deleteCartProduct(id: $id) {
    id
  }
}
    `;
export const useDeleteCartProductMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		DeleteCartProductMutation,
		TError,
		DeleteCartProductMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		DeleteCartProductMutation,
		TError,
		DeleteCartProductMutationVariables,
		TContext
	>(
		["DeleteCartProduct"],
		(variables?: DeleteCartProductMutationVariables) =>
			fetcher<DeleteCartProductMutation, DeleteCartProductMutationVariables>(
				client,
				DeleteCartProductDocument,
				variables,
				headers
			)(),
		options
	);
export const UpdateCartProductDocument = `
    mutation UpdateCartProduct($id: Int!, $values: UpdateCartProductInput!) {
  updateCartProduct(id: $id, values: $values) {
    id
    cartId
    productId
    quantity
    status
    addons {
      cartProductId
      productAddOnId
      productAddOn {
        id
        name
        price
      }
    }
    product {
      id
      name
      image
      price
      addons {
        id
        name
        price
      }
    }
  }
}
    `;
export const useUpdateCartProductMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		UpdateCartProductMutation,
		TError,
		UpdateCartProductMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		UpdateCartProductMutation,
		TError,
		UpdateCartProductMutationVariables,
		TContext
	>(
		["UpdateCartProduct"],
		(variables?: UpdateCartProductMutationVariables) =>
			fetcher<UpdateCartProductMutation, UpdateCartProductMutationVariables>(
				client,
				UpdateCartProductDocument,
				variables,
				headers
			)(),
		options
	);
export const AddProductToCartWithAddOnsDocument = `
    mutation AddProductToCartWithAddOns($productId: Int!, $branchId: Int!, $orderFlowId: Int!, $name: String!, $price: Int!, $quantity: Int, $productAddOnIds: [Int!]!, $subProducts: [CreateSubCartProductWithoutCartProductInput!]!, $coupon: AddProductToCartCoupon) {
  addProductToCartWithAddOns(
    productId: $productId
    quantity: $quantity
    productAddOnIds: $productAddOnIds
    subProducts: $subProducts
    branchId: $branchId
    orderFlowId: $orderFlowId
    name: $name
    price: $price
    coupon: $coupon
  ) {
    id
    cartId
    productId
    quantity
    status
    product {
      id
      name
      image
      price
    }
  }
}
    `;
export const useAddProductToCartWithAddOnsMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		AddProductToCartWithAddOnsMutation,
		TError,
		AddProductToCartWithAddOnsMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		AddProductToCartWithAddOnsMutation,
		TError,
		AddProductToCartWithAddOnsMutationVariables,
		TContext
	>(
		["AddProductToCartWithAddOns"],
		(variables?: AddProductToCartWithAddOnsMutationVariables) =>
			fetcher<
				AddProductToCartWithAddOnsMutation,
				AddProductToCartWithAddOnsMutationVariables
			>(client, AddProductToCartWithAddOnsDocument, variables, headers)(),
		options
	);
export const GetActiveCartProductDocument = `
    query GetActiveCartProduct {
  getActiveCartProduct {
    ...CartProductID
    id
    product {
      id
      name
      slug
      price
      image
      cloudinaryPublicId(publicIdSegments: 3)
      addons {
        id
        name
        price
      }
    }
    addons {
      cartProductId
      productAddOnId
      productAddOn {
        id
        name
        price
      }
    }
    quantity
  }
}
    ${CartProductIdFragmentDoc}`;
export const useGetActiveCartProductQuery = <
	TData = GetActiveCartProductQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: GetActiveCartProductQueryVariables,
	options?: UseQueryOptions<GetActiveCartProductQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetActiveCartProductQuery, TError, TData>(
		variables === undefined
			? ["GetActiveCartProduct"]
			: ["GetActiveCartProduct", variables],
		fetcher<GetActiveCartProductQuery, GetActiveCartProductQueryVariables>(
			client,
			GetActiveCartProductDocument,
			variables,
			headers
		),
		options
	);
export const GetActiveCartProductBaseDocument = `
    query GetActiveCartProductBase {
  getActiveCartProduct {
    ...CartProductID
    quantity
  }
}
    ${CartProductIdFragmentDoc}`;
export const useGetActiveCartProductBaseQuery = <
	TData = GetActiveCartProductBaseQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: GetActiveCartProductBaseQueryVariables,
	options?: UseQueryOptions<GetActiveCartProductBaseQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetActiveCartProductBaseQuery, TError, TData>(
		variables === undefined
			? ["GetActiveCartProductBase"]
			: ["GetActiveCartProductBase", variables],
		fetcher<
			GetActiveCartProductBaseQuery,
			GetActiveCartProductBaseQueryVariables
		>(client, GetActiveCartProductBaseDocument, variables, headers),
		options
	);
export const ClearCartDocument = `
    mutation ClearCart {
  clearCart
}
    `;
export const useClearCartMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ClearCartMutation,
		TError,
		ClearCartMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<ClearCartMutation, TError, ClearCartMutationVariables, TContext>(
		["ClearCart"],
		(variables?: ClearCartMutationVariables) =>
			fetcher<ClearCartMutation, ClearCartMutationVariables>(
				client,
				ClearCartDocument,
				variables,
				headers
			)(),
		options
	);
export const DeleteAndClearCartDocument = `
    mutation DeleteAndClearCart {
  deleteAndClearCart
}
    `;
export const useDeleteAndClearCartMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		DeleteAndClearCartMutation,
		TError,
		DeleteAndClearCartMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		DeleteAndClearCartMutation,
		TError,
		DeleteAndClearCartMutationVariables,
		TContext
	>(
		["DeleteAndClearCart"],
		(variables?: DeleteAndClearCartMutationVariables) =>
			fetcher<DeleteAndClearCartMutation, DeleteAndClearCartMutationVariables>(
				client,
				DeleteAndClearCartDocument,
				variables,
				headers
			)(),
		options
	);
export const MyCartDocument = `
    query MyCart {
  myCart {
    id
  }
}
    `;
export const useMyCartQuery = <TData = MyCartQuery, TError = unknown>(
	client: GraphQLClient,
	variables?: MyCartQueryVariables,
	options?: UseQueryOptions<MyCartQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<MyCartQuery, TError, TData>(
		variables === undefined ? ["MyCart"] : ["MyCart", variables],
		fetcher<MyCartQuery, MyCartQueryVariables>(
			client,
			MyCartDocument,
			variables,
			headers
		),
		options
	);
export const MyCartTotalItemsDocument = `
    query MyCartTotalItems {
  myCart {
    id
    totalItems
  }
}
    `;
export const useMyCartTotalItemsQuery = <
	TData = MyCartTotalItemsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: MyCartTotalItemsQueryVariables,
	options?: UseQueryOptions<MyCartTotalItemsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<MyCartTotalItemsQuery, TError, TData>(
		variables === undefined
			? ["MyCartTotalItems"]
			: ["MyCartTotalItems", variables],
		fetcher<MyCartTotalItemsQuery, MyCartTotalItemsQueryVariables>(
			client,
			MyCartTotalItemsDocument,
			variables,
			headers
		),
		options
	);
export const MyCartItemsDocument = `
    query MyCartItems {
  myCart {
    id
    totalProductsPrice
    promotionCarts {
      id
      promotion {
        id
        name
        cloudinaryPublicId
        rewards {
          discountUnit
          discountValue
        }
      }
      quantity
      promotionCartsOnProducts {
        quantity
        connectionType
        product {
          id
          name
          price
        }
        promotionRequirementId
        promotionRewardId
      }
    }
    productConnection {
      id
      quantity
      product {
        id
        name
        slug
        price
        image
        cloudinaryPublicId
        addons {
          id
          name
          price
        }
      }
      extraData
      price
      addons {
        cartProductId
        productAddOnId
        productAddOn {
          id
          name
          price
        }
      }
      subCartProducts {
        id
        product {
          id
          name
        }
        mealItemCategory {
          id
          quantity
          category {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useMyCartItemsQuery = <TData = MyCartItemsQuery, TError = unknown>(
	client: GraphQLClient,
	variables?: MyCartItemsQueryVariables,
	options?: UseQueryOptions<MyCartItemsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<MyCartItemsQuery, TError, TData>(
		variables === undefined ? ["MyCartItems"] : ["MyCartItems", variables],
		fetcher<MyCartItemsQuery, MyCartItemsQueryVariables>(
			client,
			MyCartItemsDocument,
			variables,
			headers
		),
		options
	);
export const MyCartItemIdsDocument = `
    query MyCartItemIds {
  myCart {
    promotionCarts {
      promotionId
      quantity
    }
    productConnection {
      quantity
      productId
      extraData
    }
  }
}
    `;
export const useMyCartItemIdsQuery = <
	TData = MyCartItemIdsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: MyCartItemIdsQueryVariables,
	options?: UseQueryOptions<MyCartItemIdsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<MyCartItemIdsQuery, TError, TData>(
		variables === undefined ? ["MyCartItemIds"] : ["MyCartItemIds", variables],
		fetcher<MyCartItemIdsQuery, MyCartItemIdsQueryVariables>(
			client,
			MyCartItemIdsDocument,
			variables,
			headers
		),
		options
	);
export const ListCategoriesWithProductsDocument = `
    query ListCategoriesWithProducts {
  listCategories {
    edges {
      id
      name
      products {
        id
        name
        price
      }
    }
  }
}
    `;
export const useListCategoriesWithProductsQuery = <
	TData = ListCategoriesWithProductsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: ListCategoriesWithProductsQueryVariables,
	options?: UseQueryOptions<ListCategoriesWithProductsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListCategoriesWithProductsQuery, TError, TData>(
		variables === undefined
			? ["ListCategoriesWithProducts"]
			: ["ListCategoriesWithProducts", variables],
		fetcher<
			ListCategoriesWithProductsQuery,
			ListCategoriesWithProductsQueryVariables
		>(client, ListCategoriesWithProductsDocument, variables, headers),
		options
	);
export const ValidateCouponDocument = `
    mutation ValidateCoupon($input: ValidateCouponInput!) {
  validateCoupon(input: $input) {
    error
    coupon {
      code
      userName
      discountLevel
    }
  }
}
    `;
export const useValidateCouponMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		ValidateCouponMutation,
		TError,
		ValidateCouponMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		ValidateCouponMutation,
		TError,
		ValidateCouponMutationVariables,
		TContext
	>(
		["ValidateCoupon"],
		(variables?: ValidateCouponMutationVariables) =>
			fetcher<ValidateCouponMutation, ValidateCouponMutationVariables>(
				client,
				ValidateCouponDocument,
				variables,
				headers
			)(),
		options
	);
export const OrderHistoryDocument = `
    query orderHistory {
  historyOrders {
    id
    code
    status
    createdAt
    scheduledAt
    branch {
      name
    }
    snapshot {
      order_flow
      notes
      fee_breakdown {
        subtotal
        fees {
          name
          value
          percentage
        }
        discounts {
          name
          value
          unit
          price
        }
        taxes {
          name
          value
          percentage
        }
      }
      items {
        product_id
        name
        quantity
        price
        modifiers {
          cart_modifier_id
          modifier_id
          name
          price
          quantity
        }
        coupon {
          code
          discount_value
          original_price
        }
      }
    }
  }
}
    `;
export const useOrderHistoryQuery = <
	TData = OrderHistoryQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: OrderHistoryQueryVariables,
	options?: UseQueryOptions<OrderHistoryQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<OrderHistoryQuery, TError, TData>(
		variables === undefined ? ["orderHistory"] : ["orderHistory", variables],
		fetcher<OrderHistoryQuery, OrderHistoryQueryVariables>(
			client,
			OrderHistoryDocument,
			variables,
			headers
		),
		options
	);
export const CheckoutDocument = `
    mutation Checkout($input: CheckoutInput!) {
  checkout(input: $input) {
    invoiceUrl
    order {
      code
    }
  }
}
    `;
export const useCheckoutMutation = <TError = unknown, TContext = unknown>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		CheckoutMutation,
		TError,
		CheckoutMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<CheckoutMutation, TError, CheckoutMutationVariables, TContext>(
		["Checkout"],
		(variables?: CheckoutMutationVariables) =>
			fetcher<CheckoutMutation, CheckoutMutationVariables>(
				client,
				CheckoutDocument,
				variables,
				headers
			)(),
		options
	);
export const ListProductsDocument = `
    query ListProducts($take: Int!) {
  listProducts(take: $take) {
    edges {
      id
      name
      slug
      description
      image
      cloudinaryPublicId
      price
      category {
        id
        name
      }
      labels {
        id
        name
      }
    }
  }
}
    `;
export const useListProductsQuery = <
	TData = ListProductsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables: ListProductsQueryVariables,
	options?: UseQueryOptions<ListProductsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListProductsQuery, TError, TData>(
		["ListProducts", variables],
		fetcher<ListProductsQuery, ListProductsQueryVariables>(
			client,
			ListProductsDocument,
			variables,
			headers
		),
		options
	);
export const GetProductDocument = `
    query GetProduct($id: Int!, $branchId: Int!, $couponCode: String) {
  getProduct(id: $id, branchId: $branchId, couponCode: $couponCode) {
    ... on Product {
      id
      name
      slug
      description
      image
      cloudinaryPublicId
      price
      addons {
        id
        name
        price
      }
      labels {
        id
        name
      }
      mealItemProducts {
        quantity
        childProduct {
          id
          name
        }
      }
      coupon {
        code
        discountValue
        quantity
      }
      mealItemCategories {
        id
        quantity
        category {
          id
          name
        }
      }
    }
  }
}
    `;
export const useGetProductQuery = <TData = GetProductQuery, TError = unknown>(
	client: GraphQLClient,
	variables: GetProductQueryVariables,
	options?: UseQueryOptions<GetProductQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetProductQuery, TError, TData>(
		["GetProduct", variables],
		fetcher<GetProductQuery, GetProductQueryVariables>(
			client,
			GetProductDocument,
			variables,
			headers
		),
		options
	);
export const ListMenuSectionsDocument = `
    query ListMenuSections($branchId: Int!, $couponCode: String) {
  listMenuSections(branchId: $branchId, couponCode: $couponCode) {
    special {
      id
      name
      position
      items {
        id
        name
        image
        cloudinaryPublicId
        slug
        description
        position
        price
        labels {
          id
          name
          position
        }
        coupon {
          code
          discountValue
        }
      }
    }
    main {
      id
      name
      position
      items {
        id
        name
        image
        cloudinaryPublicId
        slug
        description
        position
        price
        labels {
          id
          name
          position
        }
      }
    }
  }
}
    `;
export const useListMenuSectionsQuery = <
	TData = ListMenuSectionsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables: ListMenuSectionsQueryVariables,
	options?: UseQueryOptions<ListMenuSectionsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListMenuSectionsQuery, TError, TData>(
		["ListMenuSections", variables],
		fetcher<ListMenuSectionsQuery, ListMenuSectionsQueryVariables>(
			client,
			ListMenuSectionsDocument,
			variables,
			headers
		),
		options
	);
export const AddPromotionToCartDocument = `
    mutation AddPromotionToCart($values: AddPromotionToCartInput!) {
  addPromotionToCart(values: $values) {
    id
  }
}
    `;
export const useAddPromotionToCartMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		AddPromotionToCartMutation,
		TError,
		AddPromotionToCartMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		AddPromotionToCartMutation,
		TError,
		AddPromotionToCartMutationVariables,
		TContext
	>(
		["AddPromotionToCart"],
		(variables?: AddPromotionToCartMutationVariables) =>
			fetcher<AddPromotionToCartMutation, AddPromotionToCartMutationVariables>(
				client,
				AddPromotionToCartDocument,
				variables,
				headers
			)(),
		options
	);
export const UpdatePromotionCartDocument = `
    mutation UpdatePromotionCart($id: Int!, $values: UpdatePromotionCartInput!) {
  updatePromotionCart(id: $id, values: $values) {
    id
    quantity
  }
}
    `;
export const useUpdatePromotionCartMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		UpdatePromotionCartMutation,
		TError,
		UpdatePromotionCartMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		UpdatePromotionCartMutation,
		TError,
		UpdatePromotionCartMutationVariables,
		TContext
	>(
		["UpdatePromotionCart"],
		(variables?: UpdatePromotionCartMutationVariables) =>
			fetcher<
				UpdatePromotionCartMutation,
				UpdatePromotionCartMutationVariables
			>(client, UpdatePromotionCartDocument, variables, headers)(),
		options
	);
export const DeletePromotionCartDocument = `
    mutation DeletePromotionCart($id: Int!) {
  deletePromotionCart(id: $id) {
    id
  }
}
    `;
export const useDeletePromotionCartMutation = <
	TError = unknown,
	TContext = unknown
>(
	client: GraphQLClient,
	options?: UseMutationOptions<
		DeletePromotionCartMutation,
		TError,
		DeletePromotionCartMutationVariables,
		TContext
	>,
	headers?: RequestInit["headers"]
) =>
	useMutation<
		DeletePromotionCartMutation,
		TError,
		DeletePromotionCartMutationVariables,
		TContext
	>(
		["DeletePromotionCart"],
		(variables?: DeletePromotionCartMutationVariables) =>
			fetcher<
				DeletePromotionCartMutation,
				DeletePromotionCartMutationVariables
			>(client, DeletePromotionCartDocument, variables, headers)(),
		options
	);
export const ListPromotionsDocument = `
    query ListPromotions($where: PromotionWhereInput) {
  listPromotions(where: $where) {
    edges {
      id
      name
      validFrom
      validUntil
      image
      cloudinaryPublicId
    }
  }
}
    `;
export const useListPromotionsQuery = <
	TData = ListPromotionsQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables?: ListPromotionsQueryVariables,
	options?: UseQueryOptions<ListPromotionsQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListPromotionsQuery, TError, TData>(
		variables === undefined
			? ["ListPromotions"]
			: ["ListPromotions", variables],
		fetcher<ListPromotionsQuery, ListPromotionsQueryVariables>(
			client,
			ListPromotionsDocument,
			variables,
			headers
		),
		options
	);
export const GetPromotionDocument = `
    query GetPromotion($id: Int!) {
  getPromotion(id: $id) {
    id
    name
    validFrom
    validUntil
    image
    cloudinaryPublicId
    requirements {
      id
      quantity
      productId
      product {
        name
      }
      categoryId
      category {
        name
      }
    }
    rewards {
      id
      quantity
      productId
      product {
        id
        name
      }
      categoryId
      category {
        id
        name
      }
      discountUnit
      discountValue
    }
  }
}
    `;
export const useGetPromotionQuery = <
	TData = GetPromotionQuery,
	TError = unknown
>(
	client: GraphQLClient,
	variables: GetPromotionQueryVariables,
	options?: UseQueryOptions<GetPromotionQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<GetPromotionQuery, TError, TData>(
		["GetPromotion", variables],
		fetcher<GetPromotionQuery, GetPromotionQueryVariables>(
			client,
			GetPromotionDocument,
			variables,
			headers
		),
		options
	);
export const ListTaxesDocument = `
    query listTaxes {
  listTaxes {
    edges {
      name
      percentage
      id
    }
  }
}
    `;
export const useListTaxesQuery = <TData = ListTaxesQuery, TError = unknown>(
	client: GraphQLClient,
	variables?: ListTaxesQueryVariables,
	options?: UseQueryOptions<ListTaxesQuery, TError, TData>,
	headers?: RequestInit["headers"]
) =>
	useQuery<ListTaxesQuery, TError, TData>(
		variables === undefined ? ["listTaxes"] : ["listTaxes", variables],
		fetcher<ListTaxesQuery, ListTaxesQueryVariables>(
			client,
			ListTaxesDocument,
			variables,
			headers
		),
		options
	);
